<template>
  <div>
    <base-header class="pb-4">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ getPageTitle() }}
          </h6>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <base-button
            size="sm"
            type="neutral"
            @click="loadExternalAlbaranes"
            :loading="loadingExternal"
            class="mr-2"
          >
            <i class="fas fa-sync mr-2"></i>
            Cargar albaranes
          </base-button>

          <base-button
            size="sm"
            type="neutral"
            @click="addAlbaran()"
            :loading="loading"
            class="mr-2"
          >Crear albarán</base-button>
          <base-button
            size="sm"
            type="neutral"
            @click="goToStats()"
          >
            <i class="fas fa-chart-bar mr-2"></i>
            Estadísticas
          </base-button>
        </div>
      </div>
      <!-- Card stats -->
      <!-- KPIs DINÁMICOS SEGÚN LA VISTA -->
      <div v-if="currentView === 'list'" class="kpi-container">
        <!-- Pendientes -->
        <div class="kpi-item">
          <stats-card-img
            title="Pendientes"
            type="gradient-warning"
            :sub-title="totalPendientesAsignar ? totalPendientesAsignar.toString() : '0'"
            img="/img/ios-time.png"
          >
            <template slot="footer">
              <span class="text-warning mr-2">{{ porcentajePendientesAsignar }}%</span>
              <span class="text-nowrap">del total</span>
            </template>
          </stats-card-img>
        </div>

        <!-- Asignados -->
        <div class="kpi-item">
          <stats-card-img
            title="Asignados"
            type="gradient-info"
            :sub-title="totalAsignados ? totalAsignados.toString() : '0'"
            img="/img/ios-checkmark-orange.png"
          >
            <template slot="footer">
              <span class="text-info mr-2">{{ porcentajeAsignados }}%</span>
              <span class="text-nowrap">del total</span>
            </template>
          </stats-card-img>
        </div>

        <!-- Cerrados -->
        <div class="kpi-item">
          <stats-card-img
            title="Cerrados"
            type="gradient-success"
            :sub-title="totalCerrados ? totalCerrados.toString() : '0'"
            img="/img/ios-checkmark-circle.png"
          >
            <template slot="footer">
              <span class="text-success mr-2">{{ porcentajeCerrados }}%</span>
              <span class="text-nowrap">del total</span>
            </template>
          </stats-card-img>
        </div>
      </div>

      <!-- KPIs DEL MES PARA VISTA DE CALENDARIO -->
      <div v-if="currentView === 'calendar'" class="kpi-container">
        <!-- Pendientes -->
        <div class="kpi-item">
          <stats-card-img
            title="Pendientes"
            type="gradient-warning"
            :sub-title="totalPendientesAsignar ? totalPendientesAsignar.toString() : '0'"
            img="/img/ios-time.png"
          >
            <template slot="footer">
              <span class="text-warning mr-2">{{ porcentajePendientesAsignar }}%</span>
              <span class="text-nowrap">del total</span>
            </template>
          </stats-card-img>
        </div>

        <!-- Asignados -->
        <div class="kpi-item">
          <stats-card-img
            title="Asignados"
            type="gradient-info"
            :sub-title="totalAsignados ? totalAsignados.toString() : '0'"
            img="/img/ios-checkmark-orange.png"
          >
            <template slot="footer">
              <span class="text-info mr-2">{{ porcentajeAsignados }}%</span>
              <span class="text-nowrap">del total</span>
            </template>
          </stats-card-img>
        </div>

        <!-- Cerrados -->
        <div class="kpi-item">
          <stats-card-img
            title="Cerrados"
            type="gradient-success"
            :sub-title="totalCerrados ? totalCerrados.toString() : '0'"
            img="/img/ios-checkmark-circle.png"
          >
            <template slot="footer">
              <span class="text-success mr-2">{{ porcentajeCerrados }}%</span>
              <span class="text-nowrap">del total</span>
            </template>
          </stats-card-img>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--4">
      <div class="row">
        <div class="col">
          <card
            class="no-border-card"
            body-classes="px-0 pb-1"
            footer-classes="pb-2"
          >
            <div class="p-2">
              <!-- TÍTULO DE LA PÁGINA -->
              <div class="row mb-4">
                <div class="col-12">
                  <h3 class="mb-0">{{ getPageTitle() }}</h3>
                  <p class="text-muted mb-0">
                    <span v-if="currentView === 'list'">Gestiona los albaranes del día seleccionado</span>
                    <span v-else>Visualiza todos los albaranes del mes en el calendario</span>
                  </p>
                </div>
              </div>
              
              <!-- FILTROS PRINCIPALES EN UNA LÍNEA -->
              <div class="row mb-3">
                <!-- BÚSQUEDA GLOBAL -->
                <div class="col-md-6">
                  <div class="filter-group">
                    <label class="filter-label">
                      <i class="fas fa-search mr-2"></i>
                      Búsqueda Global
                    </label>
                    <div class="d-flex align-items-stretch albaran-search-row">
                      <base-input
                        v-model="queryInput"
                        type="search"
                        prepend-icon="fas fa-search"
                        placeholder="Buscar por número, título, cliente, descripción..."
                        clearable
                        class="flex-grow-1 mr-2 albaran-search-input"
                        @keyup.enter.native="triggerSearch"
                      />
                      <base-button
                        size="sm"
                        type="primary"
                        @click="triggerSearch"
                        :disabled="loading"
                        title="Buscar"
                        class="albaran-search-btn"
                      >
                        <i class="fas fa-search mr-2"></i>
                        Buscar
                      </base-button>
                    </div>
                  </div>
                </div>
                
                <!-- NAVEGACIÓN POR DÍAS/MESES Y VISTA -->
                <div class="col-md-6">
                  <div class="row">
                    <!-- NAVEGACIÓN POR MESES (para calendario y listado) -->
                    <div class="col-8">
                      <div class="filter-group">
                        <label class="filter-label">
                          <i class="fas fa-calendar-alt mr-2"></i>
                          <span>Navegación por Meses</span>
                        </label>
                        <!-- Navegación por meses (vista calendario y listado) -->
                        <div class="month-navigation-compact">
                          <div class="btn-group w-100" role="group">
                            <button
                              type="button"
                              class="btn btn-corporate"
                              @click="previousMonth"
                              title="Mes anterior"
                            >
                              <i class="fas fa-chevron-left"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-corporate"
                              @click="today"
                            >
                              <i class="fas fa-calendar-day mr-1"></i>
                              Hoy
                            </button>
                            <button
                              type="button"
                              class="btn btn-corporate"
                              @click="nextMonth"
                              title="Mes siguiente"
                            >
                              <i class="fas fa-chevron-right"></i>
                            </button>
                  </div>
                </div>
                      </div>
                    </div>
                    
                    <!-- SELECTOR DE VISTA -->
                    <div class="col-4">
                      <div class="filter-group">
                        <label class="filter-label">
                          <i class="fas fa-eye mr-2"></i>
                          Vista
                        </label>
                        <div class="btn-group w-100" role="group">
                          <button
                            type="button"
                            class="btn btn-corporate"
                            :class="{ 'active': currentView === 'list' }"
                            @click="setView('list')"
                            title="Vista de Lista"
                          >
                            <i class="fas fa-list"></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-corporate"
                            :class="{ 'active': currentView === 'calendar' }"
                            @click="setView('calendar')"
                            title="Vista de Calendario"
                          >
                            <i class="fas fa-calendar-alt"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- SUBFILTROS (ESPECÍFICOS DEL DÍA) - Solo si hay 2+ albaranes -->
              <div v-if="shouldShowSubfilters" class="row mb-3">
                <div class="col-md-4">
                  <div class="filter-group">
                    <label class="filter-label">
                      <i class="fas fa-tasks mr-2"></i>
                      Tarea Asociada
                    </label>
                  <div :class="{ 'has-filter': tareaAsociada !== 'Todos' }">
                      <select 
                        v-model="tareaAsociada" 
                        class="form-control"
                        @change="getList"
                      >
                        <option value="Todos">Todas las tareas</option>
                        <option value="Con tarea">Con tarea de Keikaku</option>
                        <option value="Sin tarea">Sin tarea de Keikaku</option>
                      </select>
                  </div>
                </div>
                    </div>
                <div class="col-md-4">
                  <div class="filter-group">
                    <label class="filter-label">
                      <i class="fas fa-flag mr-2"></i>
                      Estado del Albarán
                    </label>
                    <div :class="{ 'has-filter': estado !== 'Todos' }">
                      <el-select
                        class="select-primary"
                        v-model="estado"
                        placeholder="Todos los estados"
                        style="width: 100%; height: 46px !important"
                        @change="getList"
                      >
                        <el-option
                          class="select-primary"
                          v-for="item in estados"
                          :key="item"
                          :label="item"
                          :value="item"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="filter-group">
                    <label class="filter-label">
                      <i class="fas fa-building mr-2"></i>
                      Proyecto
                    </label>
                    <div :class="{ 'has-filter': proyectoFiltro !== 'Todos' }">
                      <el-select
                        class="select-primary"
                        v-model="proyectoFiltro"
                        placeholder="Todos los proyectos"
                        style="width: 100%; height: 46px !important"
                        @change="getList"
                        filterable
                      >
                        <el-option
                          class="select-primary"
                          label="Todos los proyectos"
                          value="Todos"
                        >
                        </el-option>
                        <el-option
                          class="select-primary"
                          v-for="proyecto in proyectosDisponibles"
                          :key="proyecto"
                          :label="proyecto"
                          :value="proyecto"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>

              <!-- BOTÓN LIMPIAR FILTROS -->
              <div class="row mb-3" v-if="hasActiveFilters">
                <div class="col-12 text-right">
                  <button
                    class="btn btn-outline-secondary btn-sm"
                    @click="clearSearchState"
                    title="Limpiar todos los filtros"
                  >
                    <i class="fas fa-times-circle mr-2"></i>
                    Limpiar Filtros
                  </button>
                </div>
              </div>
              <!-- VISTA DE LISTA -->
              <div v-if="currentView === 'list'">
                <div class="mb-3 d-flex justify-content-end">
                  <base-button
                    size="sm"
                    type="primary"
                    @click="refrescarListado"
                    :loading="loading"
                    title="Actualizar listado"
                  >
                    <i class="fas fa-sync-alt mr-2" :class="{ 'fa-spin': loading }"></i>
                    Actualizar
                  </base-button>
                </div>
              <el-table
                ref="multipleTable"
                class="table-responsive align-items-center table-flush"
                header-row-class-name="thead-light"
                :data="albaranes"
                :row-class-name="getRowClass"
                :default-sort="{prop: 'fecha_entrega', order: 'descending'}"
                @sort-change="sortChange"
                @row-click="handleRowClick"
                empty-text="No hay ningún elemento en esta tabla"
                :highlight-current-row="false"
              >
                <!-- LOADING-->
                <div slot="empty" v-if="loading">
                  <img
                    src="/img/loading.gif"
                    style="height: 100px; width: 100px"
                  />
                </div>
                <!-- Checkbox de selección múltiple oculto -->
                <!-- <el-table-column type="selection" width="30">
                </el-table-column> -->

                <el-table-column
                  label="Día"
                  prop="fecha_entrega"
                  min-width="120"
                  sortable="custom"
                  :sort-method="sortByFechaEntrega"
                >
                  <template v-slot="{ row }">
                    <div class="d-flex flex-column">
                      <span>{{ formatDiaAlbaran(row) }}</span>
                      <span 
                        v-if="row.attributes?.es_clon || row.es_clon" 
                        class="badge badge-clon mt-1"
                        title="Albarán clonado"
                      >
                        <i class="fas fa-copy"></i> Clon
                      </span>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  label="Número"
                  prop="numero"
                  min-width="90"
                  sortable="custom"
                >
                  <template v-slot="{ row }">
                    <div class="d-flex flex-column">
                      <b>{{ row.attributes?.numero || row.numero }}</b>
                      <span
                        v-if="getDuplicadosHoyCount(row) > 1"
                        class="badge badge-warning text-white mt-1"
                        style="width: fit-content;"
                        :title="`Hay ${getDuplicadosHoyCount(row)} albaranes HOY con la misma tarea Keikaku. Entra en uno y usa Importar para fusionar.`"
                      >
                        <i class="fas fa-link mr-1"></i>
                        Duplicado ({{ getDuplicadosHoyCount(row) }})
                      </span>
                      <span
                        v-if="row.attributes?.es_facturable || row.es_facturable"
                        class="badge px-2 text-white mt-1"
                        style="font-size: 0.75rem; background-color: #1e3a5f !important; color: white !important; width: fit-content;"
                      >
                        <i class="fas fa-euro-sign"></i>
                      </span>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  label="Cliente"
                  prop="cliente"
                  min-width="180"
                  sortable="custom"
                >
                  <template v-slot="{ row }">
                    <span>{{ row.attributes?.cliente || row.cliente || 'Sin especificar' }}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  label="Descripción"
                  prop="titulo"
                  min-width="250"
                  sortable="custom"
                >
                  <template v-slot="{ row }">
                    <span>{{ row.attributes?.titulo || row.titulo }}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  label="Estado"
                  min-width="110"
                  prop="estado"
                  sortable="custom"
                >
                  <template slot-scope="{ row }">
                    <span
                      :class="['badge', getEstadoBadgeClass(getEstadoAlbaran(row)), 'estado-badge-listado']"
                      :style="{ backgroundColor: getEstadoColor(getEstadoAlbaran(row)) === 'transparent' ? 'rgba(255, 255, 255, 0.3)' : getEstadoColor(getEstadoAlbaran(row)), color: '#ffffff' }"
                    >
                      {{ formatEstado(getEstadoAlbaran(row)) }}
                    </span>
                  </template>
                </el-table-column>

                <el-table-column
                  label="Asignado a"
                  min-width="200"
                  sortable="custom"
                >
                  <template slot-scope="{ row }">
                    <div v-if="(row.attributes?.estado || row.estado) === 'asignado' && (row.attributes?.users_permissions_user || row.users_permissions_user)" class="d-flex align-items-center">
                      <img
                        v-if="(row.attributes?.users_permissions_user || row.users_permissions_user).imagen_perfil"
                        :src="(row.attributes?.users_permissions_user || row.users_permissions_user).imagen_perfil.url"
                        class="avatar avatar-xs rounded-circle mr-2"
                      />
                      <img
                        v-else
                        src="/img/placeholder.png"
                        class="avatar avatar-xs rounded-circle mr-2"
                      />
                      <span>
                        {{ (row.attributes?.users_permissions_user || row.users_permissions_user).nombre }} 
                        {{ (row.attributes?.users_permissions_user || row.users_permissions_user).apellidos }}
                        <small class="text-muted d-block">{{ (row.attributes?.users_permissions_user || row.users_permissions_user).email }}</small>
                      </span>
                    </div>
                    <span v-else class="text-muted">-</span>
                  </template>
                </el-table-column>

                <el-table-column
                  label="Material"
                  min-width="100"
                  align="center"
                  sortable="custom"
                >
                  <template slot-scope="{ row }">
                    <el-tooltip 
                      :content="getMaterialesTallerTooltip(row)" 
                      placement="top"
                      :disabled="!getMaterialesTallerCount(row)"
                    >
                      <span>{{ getMaterialesTallerCount(row) }}</span>
                    </el-tooltip>
                  </template>
                </el-table-column>

                <!-- Columna de acciones oculta - ahora se accede pinchando sobre la fila -->
                <!-- <el-table-column label="Acciones" align="right" min-width="120" fixed="right">
                  <div slot-scope="{ row }" class="table-actions">
                    <el-tooltip content="Ver detalles" placement="top">
                      <base-button
                        @click="viewAlbaran(row)"
                        class="edit"
                        type="primary"
                        size="sm"
                        icon
                      >
                        <i class="fas fa-eye"></i>
                      </base-button>
                    </el-tooltip>

                    <el-tooltip content="Eliminar" placement="top">
                      <base-button
                        @click="deleteAlbaran(row.id)"
                        class="remove"
                        type="danger"
                        size="sm"
                        icon
                      >
                        <i class="fas fa-trash"></i>
                      </base-button>
                    </el-tooltip>
                  </div>
                </el-table-column> -->
              </el-table>
              </div>

              <!-- VISTA DE CALENDARIO -->
              <div v-if="currentView === 'calendar'" class="calendar-container">
                <div class="calendar-header mb-3">
                  <div class="row align-items-center">
                    <div class="col-8">
                      <h5 class="mb-0">
                        <i class="fas fa-calendar-alt mr-2"></i>
                        Calendario de Albaranes - {{ formatCalendarMonth(calendarDate) }}
                      </h5>
                      <small class="text-muted">Todos los albaranes del mes</small>
                    </div>
                    <div class="col-4 text-right">
                      <base-button
                        size="sm"
                        type="primary"
                        @click="refrescarListado"
                        :loading="loading"
                        title="Actualizar calendario"
                      >
                        <i class="fas fa-sync-alt mr-2" :class="{ 'fa-spin': loading }"></i>
                        Actualizar
                      </base-button>
                    </div>
                  </div>
                </div>

                <!-- Calendario Simple -->
                <div class="calendar-grid">
                  <div class="calendar-month-header">
                    <h4 class="text-center mb-3">
                      {{ formatCalendarMonth(calendarDate) }}
                    </h4>
                  </div>
                  
                  <div class="calendar-weekdays">
                    <div class="calendar-weekday" v-for="day in weekdays" :key="day">
                      {{ day }}
                    </div>
                  </div>
                  
                  <div class="calendar-days">
                    <div
                      v-for="(day, index) in calendarDays"
                      :key="day.date || `empty-${index}`"
                      class="calendar-day"
                      :class="{
                        'other-month': !day.isCurrentMonth || day.isEmpty,
                        'today': day.isToday,
                        'has-events': day.events.length > 0,
                        'empty-day': day.isEmpty
                      }"
                    >
                      <div class="day-number" v-if="!day.isEmpty">{{ day.day }}</div>
                      <div class="day-events" v-if="!day.isEmpty">
                        <div
                          v-for="event in day.events"
                          :key="event.id"
                          class="event-item"
                          :style="{ backgroundColor: event.backgroundColor }"
                          @click="viewAlbaran(event.extendedProps.albaran)"
                          :title="event.title"
                        >
                          <div class="event-content">
                            <div class="event-header">
                              <span class="event-numero">{{ getEventNumero(event) }}</span>
                              </div>
                            <div
                              v-if="getDuplicadosHoyCount(event.extendedProps.albaran) > 1"
                              class="event-duplicado-row"
                            >
                              <span
                                class="event-duplicado-badge"
                                :title="`Hay ${getDuplicadosHoyCount(event.extendedProps.albaran)} albaranes HOY con la misma tarea Keikaku. Entra en uno y usa Importar para fusionar.`"
                              >
                                <i class="fas fa-link mr-1"></i>
                                Dup ({{ getDuplicadosHoyCount(event.extendedProps.albaran) }})
                              </span>
                            </div>
                            <div class="event-estado-wrapper">
                              <span 
                                class="event-estado"
                                :style="{ backgroundColor: getEventEstadoBadgeColor(event), color: '#ffffff' }"
                              >{{ getEventEstado(event) }}</span>
                            </div>
                            <div class="event-titulo">{{ getEventTitulo(event) }}</div>
                            <div v-if="getEventResponsable(event)" class="event-responsable">{{ getEventResponsable(event) }}</div>
                            <div class="event-tarea-parte">
                              <span v-if="getEventTarea(event)">Tarea: {{ getEventTarea(event) }}</span>
                              <span v-else class="sin-tarea-keikaku">Sin tarea keikaku</span>
                              <span v-if="getEventParte(event)" class="ml-2">| Parte: {{ getEventParte(event) }}</span>
                            </div>
                            <div class="event-material">{{ getEventMaterial(event) }}</div>
                          </div>
                          <!-- Símbolo del dinero en esquina inferior derecha -->
                          <div
                            v-if="getEventEsFacturable(event)"
                            class="event-facturable-icon"
                          >
                            <i class="fas fa-euro-sign"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="row">
                <div class="col-xl-4">
                  <el-select
                    class="select-primary pagination-select"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>

                <div class="col-xl-8">
                  <p class="card-category" style="margin-top: 0.5rem">
                    Mostrando {{ total ? from + 1 : 0 }} - {{ to }} de
                    {{ total }} registros

                    <!-- Contador de filas seleccionadas oculto -->
                    <!-- <span v-if="selectedRows.length">
                      &nbsp; &nbsp; {{ selectedRows.length }} filas seleccionadas
                    </span> -->
                  </p>
                </div>
              </div>

              <base-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
              />
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "@/components";
import swal from "sweetalert2";
import moment from "moment";
// import flatPicker from "vue-flatpickr-component";
// import "flatpickr/dist/flatpickr.css";
import axios from 'axios';
import { debounce } from 'lodash';
import { getEstadoColor as getEstadoColorUtil, getEstadoBadgeClass as getEstadoBadgeClassUtil, getEstadoTexto as getEstadoTextoUtil } from "@/util/estadoColors";
import { KEIKAKU_ACCESS_TOKEN, SAT_ACCESS_TOKEN, KEIKAKU_API_BASE_URL, SAT_API_BASE_URL } from "@/config/externalApiTokens";

export default {
  name: "list-albaran",
  components: {
    BasePagination,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Option.name]: Option,
    [Select.name]: Select
    // flatPicker
  },
  data() {
    return {
      albaranes: [],
      selectedRows: [],
      loading: false,
      // Búsqueda:
      // - queryInput: lo que escribe el usuario (NO debe lanzar llamadas)
      // - query: query aplicada (solo cambia al pulsar Buscar/Enter)
      queryInput: "",
      query: "",
      isRestoringState: false,
      selectedDate: "",
      fdesde: "",
      fhasta: "",
      sort: ["fecha_entrega:desc"],
      total: 0,
      // Variables para vista de calendario
      currentView: 'calendar', // 'list' o 'calendar'
      calendarDate: new Date(),
      calendarEvents: [],
      calendarFilterDate: '', // Filtro de fecha específica para el calendario
      // Variables para navegación por días en vista lista
      selectedDay: new Date(), // Día seleccionado para la vista lista
      estados: [
        "Todos",
        "Sin Asignar",
        "Asignado",
        "Entregado",
        "Devuelto",
        "Revisar Devolución",
        "Cerrado",
        "Cerrado sin tarea",
        "Mat. Abandonado"
      ],
      estado: "Todos",
      tareaAsociada: "Todos", // Nuevo filtro
      esClon: "Todos", // Nuevo filtro
      proyectoFiltro: "Todos", // Filtro por proyecto
      proyectosDisponibles: [], // Lista de proyectos únicos disponibles
      pagination: {
        perPage: 100,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100],
      },
      totalPendientesAsignar: 0,
      totalPendientesAceptar: 0,
      totalAsignados: 0,
      totalDevueltos: 0,
      totalCerrados: 0,
      totalClones: 0, // Nuevo KPI
      totalCerradosSinTarea: 0, // Nuevo KPI
      totalAlbaranesConTarea: 0, // Nuevo KPI
      totalAlbaranesSinTarea: 0, // Nuevo KPI
      isInitialLoad: true, // Flag para evitar llamadas duplicadas en el montaje
      configInput: {
        dateFormat: "d-m-Y",
        locale: {
          firstDayOfWeek: 1,
          weekdays: {
            shorthand: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
            longhand: [
              "Domingo",
              "Lunes",
              "Martes",
              "Miércoles",
              "Jueves",
              "Viernes",
              "Sábado",
            ],
          },
          months: {
            shorthand: [
              "Ene",
              "Feb",
              "Mar",
              "Abr",
              "May",
              "Jun",
              "Jul",
              "Ago",
              "Sep",
              "Oct",
              "Nov",
              "Dic",
            ],
            longhand: [
              "Enero",
              "Febrero",
              "Marzo",
              "Abril",
              "Mayo",
              "Junio",
              "Julio",
              "Agosto",
              "Septiembre",
              "Octubre",
              "Noviembre",
              "Diciembre",
            ],
          },
        },
      },
      configCalendar: {
        dateFormat: "d-m-Y",
        locale: {
          firstDayOfWeek: 1,
          weekdays: {
            shorthand: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
            longhand: [
              "Domingo",
              "Lunes",
              "Martes",
              "Miércoles",
              "Jueves",
              "Viernes",
              "Sábado",
            ],
          },
          months: {
            shorthand: [
              "Ene",
              "Feb",
              "Mar",
              "Abr",
              "May",
              "Jun",
              "Jul",
              "Ago",
              "Sep",
              "Oct",
              "Nov",
              "Dic",
            ],
            longhand: [
              "Enero",
              "Febrero",
              "Marzo",
              "Abril",
              "Mayo",
              "Junio",
              "Julio",
              "Agosto",
              "Septiembre",
              "Octubre",
              "Noviembre",
              "Diciembre",
            ],
          },
        },
      },
      loadingExternal: false,
      externalApiUrl: 'https://aplicaciones.salvadorvertical.com/SAT/webapi/list/Offline_Tarea_Keikaku',
      externalApiToken: 'Bearer bhW6NyCfIA9Bo5RBsz7gNBdxbMeCk3zQybHZNuMFVvOuJRSw5mab9ZFMuPRdojH8DujFhefOCrc0JF9aHF7bOZOAY6HIZTs2Nd1yeWUnOThubnblWlkIDI6iZcgAnNrKtio2L_EPzEYG-7DZtB5cHJNUtIyyYYe7r9kjK4ZsrMVJ9vGADdF4EzfiEZPz5HDLr0H9ksJr-HGRwyChbtLfqK2z7AhhssGoB9Q8dh5xkhI4v1c_iIMs7m2y1G3cV_m3ZkbXG-T-LScT15CNb6jVoyS6HCz7P8Uc92qCAXFD_HE'
    };
  },
  mounted() {
    // Restaurar filtros si existen (y luego hacer una única carga)
    const restored = this.restoreListState();
    this.isInitialLoad = true;
    if (restored) {
      // Cargar con el estado restaurado
      this.getList();
    } else {
      // Carga por defecto (mes completo)
      if (this.currentView === 'list') {
        this.loadListMonth();
      } else if (this.currentView === 'calendar') {
        this.loadCalendarMonth();
      }
    }
  },
  activated() {
    // Refrescar automáticamente cuando se vuelve a esta vista desde otra (ej: ViewAlbaranPage)
    // Esto asegura que los colores y estados se actualicen sin necesidad de entrar y salir
    // NOTA: Este hook solo funciona si el componente está dentro de <keep-alive>
    if (!this.isInitialLoad) {
      this.refrescarListado();
    }
  },
  beforeRouteEnter(to, from, next) {
    // Este hook se ejecuta antes de entrar a la ruta
    // No tenemos acceso a 'this' aquí, así que pasamos una función callback
    next(vm => {
      // Si venimos de ViewAlbaranPage, recargar los datos para actualizar colores del calendario
      if (from.name === 'View Albaran' && !vm.isInitialLoad) {
        vm.refrescarListado();
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    // Este hook se ejecuta cuando la ruta cambia pero el componente se reutiliza
    // Si venimos de ViewAlbaranPage, recargar los datos para actualizar colores del calendario
    if (from.name === 'View Albaran' && !this.isInitialLoad) {
      this.refrescarListado();
    }
    next();
  },
  watch: {
    // Regenerar eventos del calendario cuando cambian los albaranes
    // Usamos una función que compara el estado de los albaranes para detectar cambios
    albaranes: {
      handler(newAlbaranes, oldAlbaranes) {
        // Solo regenerar si estamos en vista de calendario
        if (this.currentView !== 'calendar') return;
        
        // Si es la primera carga o el array cambió de longitud, regenerar
        if (!oldAlbaranes || newAlbaranes.length !== oldAlbaranes.length) {
          this.$nextTick(() => {
            this.generateCalendarEvents();
          });
          return;
        }
        
        // Comparar estados de los albaranes para detectar cambios
        let hayCambios = false;
        for (let i = 0; i < newAlbaranes.length; i++) {
          const nuevoAlbaran = newAlbaranes[i];
          const viejoAlbaran = oldAlbaranes[i];
          
          if (!viejoAlbaran || nuevoAlbaran.id !== viejoAlbaran.id) {
            hayCambios = true;
            break;
          }
          
          const nuevoEstado = nuevoAlbaran.attributes?.estado || nuevoAlbaran.estado;
          const viejoEstado = viejoAlbaran.attributes?.estado || viejoAlbaran.estado;
          
          if (nuevoEstado !== viejoEstado) {
            hayCambios = true;
            break;
          }
        }
        
        if (hayCambios) {
          this.$nextTick(() => {
            this.generateCalendarEvents();
          });
        }
      },
      deep: true, // Observar cambios profundos en los objetos del array
      immediate: false // No ejecutar inmediatamente, solo cuando cambie
    },
    // Regenerar eventos cuando cambia la vista a calendario
    currentView(newView) {
      if (newView === 'calendar' && this.albaranes && this.albaranes.length > 0) {
        this.$nextTick(() => {
          this.generateCalendarEvents();
        });
      }
    }
  },
  computed: {
    todayYMD() {
      return moment().format('YYYY-MM-DD');
    },
    duplicadosTareaHoy() {
      // Mapa tarea_keikaku_id -> count solo para albaranes con fecha_entrega HOY
      const map = {};
      (this.albaranes || []).forEach((row) => {
        const tareaId = row.attributes?.tarea_keikaku_id ?? row.tarea_keikaku_id;
        const fechaEntrega = row.attributes?.fecha_entrega || row.fecha_entrega;
        if (!tareaId || !fechaEntrega) return;
        const ymd = moment(fechaEntrega).format('YYYY-MM-DD');
        if (ymd !== this.todayYMD) return;
        const key = String(tareaId);
        map[key] = (map[key] || 0) + 1;
      });
      return map;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    porcentajePendientesAsignar() {
      return this.total ? Math.round((this.totalPendientesAsignar / this.total) * 100) : 0;
    },
    porcentajeAsignados() {
      return this.total ? Math.round((this.totalAsignados / this.total) * 100) : 0;
    },
    porcentajeCerrados() {
      return this.total ? Math.round((this.totalCerrados / this.total) * 100) : 0;
    },
    porcentajeClones() {
      return this.total ? Math.round((this.totalClones / this.total) * 100) : 0;
    },
    hasActiveFilters() {
      return this.query || this.estado !== "Todos" || this.tareaAsociada !== "Todos" || this.proyectoFiltro !== "Todos";
    },
    shouldShowSubfilters() {
      // Mostrar filtros siempre que haya albaranes o estemos cargando
      // Esto evita que los filtros desaparezcan cuando se aplica un filtro que reduce los resultados
      return (this.albaranes && this.albaranes.length > 0) || this.loading || this.total > 0;
    },
    weekdays() {
      return ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];
    },
    calendarDays() {
      const year = this.calendarDate.getFullYear();
      const month = this.calendarDate.getMonth();
      
      // Primer día del mes
      const firstDay = new Date(year, month, 1);
      // Último día del mes
      const lastDay = new Date(year, month + 1, 0);
      
      // Calcular qué día de la semana es el primer día del mes
      // 0 = domingo, 1 = lunes, 2 = martes, ..., 6 = sábado
      // Pero queremos que lunes sea el primer día de la semana (índice 0)
      // Entonces: domingo(0) -> 6, lunes(1) -> 0, martes(2) -> 1, ..., sábado(6) -> 5
      const firstDayOfWeek = firstDay.getDay();
      const firstDayColumn = firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1; // Convertir domingo(0) a 6, lunes(1) a 0, etc.
      
      const days = [];
      
      // Agregar días vacíos al inicio si el primer día del mes no es lunes
      if (firstDayColumn > 0) {
        for (let i = 0; i < firstDayColumn; i++) {
          days.push({
            date: null,
            day: null,
            isCurrentMonth: false,
            isToday: false,
            events: [],
            isEmpty: true
          });
        }
      }
      
      // Generar todos los días del mes (incluyendo sábados y domingos)
      const currentDate = new Date(firstDay);
      
      while (currentDate <= lastDay) {
        const dayOfWeek = currentDate.getDay(); // 0 = domingo, 1 = lunes, ..., 6 = sábado
        
          const dayEvents = this.calendarEvents
            .filter(event => {
              const eventDate = new Date(event.start);
              return eventDate.toDateString() === currentDate.toDateString();
            })
            .sort((a, b) => {
              const getNumero = (event) => {
                const albaran = event.extendedProps?.albaran || {};
                return albaran.attributes?.numero || albaran.numero || "";
              };

              const getTareaBase = (event) => {
                const albaran = event.extendedProps?.albaran || {};
                const numero = getNumero(event);
                // Soporta formatos tipo "T21681" y clones tipo "CL1T21681"
                const match = String(numero).match(/T(\d+)/i);
                if (match && match[1]) {
                  const parsed = parseInt(match[1], 10);
                  if (!Number.isNaN(parsed)) return parsed;
                }

                // Fallback: si no se puede extraer del numero, usar tarea_keikaku_id
                const tareaKeikaku = albaran.attributes?.tarea_keikaku_id || albaran.tarea_keikaku_id;
                const tareaParsed = parseInt(tareaKeikaku, 10);
                if (!Number.isNaN(tareaParsed)) return tareaParsed;
                return Number.MAX_SAFE_INTEGER;
              };

              const isClon = (event) => {
                const albaran = event.extendedProps?.albaran || {};
                const numero = getNumero(event);
                return Boolean(albaran.attributes?.es_clon || albaran.es_clon || String(numero).toUpperCase().startsWith("CL"));
              };

              const getCloneOrder = (event) => {
                const numero = getNumero(event);
                const match = String(numero).match(/^CL(\d+)/i);
                if (match && match[1]) {
                  const parsed = parseInt(match[1], 10);
                  if (!Number.isNaN(parsed)) return parsed;
                }
                return -1;
              };

              const tareaA = getTareaBase(a);
              const tareaB = getTareaBase(b);
              const clonA = isClon(a);
              const clonB = isClon(b);
              // Prioridad absoluta: clones arriba, no clones debajo
              if (clonA !== clonB) return clonA ? -1 : 1;

              // Entre clones, ordenar por índice CL en descendente: CL4 antes que CL1
              if (clonA && clonB) {
                const cloneOrderA = getCloneOrder(a);
                const cloneOrderB = getCloneOrder(b);
                if (cloneOrderA !== cloneOrderB) return cloneOrderB - cloneOrderA;
              }

              // Dentro del mismo bloque (clones/no clones), ordenar por tarea base ascendente
              if (tareaA !== tareaB) return tareaA - tareaB;

              const numeroA = getNumero(a);
              const numeroB = getNumero(b);
              return String(numeroA).localeCompare(String(numeroB), "es", {
                numeric: true,
                sensitivity: "base",
              });
            });
          
          days.push({
            date: currentDate.toISOString().split('T')[0],
            day: currentDate.getDate(),
          dayOfWeek: dayOfWeek, // Guardar el día de la semana
            isCurrentMonth: true,
            isToday: currentDate.toDateString() === new Date().toDateString(),
          events: dayEvents,
          isEmpty: false
          });
        
        currentDate.setDate(currentDate.getDate() + 1);
      }
      
      return days;
    },
    getMateriales() {
      if (!this.albaran) return [];

      // Obtener los materiales de albaran_activo_materials
      const materialesActivos = this.albaran?.albaran_activo_materials || [];

      // Obtener los consumibles de materiales_taller que tienen estado
      const consumiblesAsignados = (this.albaran?.materiales_taller || [])
        .filter(material => {
          // Verificar si es consumible por idArticulo o por descripción (idArticulo_flxtext)
          const isConsumibleById = material.idArticulo === '-' || material.idArticulo?.includes('CONS');
          const isConsumibleByDesc = material.idArticulo_flxtext && material.idArticulo_flxtext.includes('CONS');
          return isConsumibleById || isConsumibleByDesc;
        })
        .map(material => ({
          id: `cons-${material.idArticulo}`,
          activo: null,
          estado: material.estado || 'pendiente_asignar',  // Si no hay estado, es pendiente_asignar
          responsable_actual: material.responsable_actual || "jefe_taller",
          fecha_accion: material.fecha_accion || new Date().toISOString(),
          observaciones: material.observaciones || `Consumible: ${material.idArticulo_flxtext} - Cantidad: ${material.cantidad}`,
          idArticulo: material.idArticulo,
          idArticulo_flxtext: material.idArticulo_flxtext,
          cantidad: material.cantidad,
          usuario_accion: material.usuario_accion
        }));

      // Combinar ambos arrays
      return [...materialesActivos, ...consumiblesAsignados];
    },
  },
  watch: {
    estado: {
      handler() {
        if (this.isRestoringState) return;
        this.saveListState();
        this.getListDebounced();
      },
      immediate: false, // No ejecutar inmediatamente, se carga en mounted
    },
    selectedDate: {
      handler: "handleSelectedDateChange",
      immediate: false,
    },
    fdesde: {
      handler() {
        if (this.isRestoringState) return;
        this.saveListState();
        this.getListDebounced();
      },
      immediate: false,
    },
    fhasta: {
      handler() {
        if (this.isRestoringState) return;
        this.saveListState();
        this.getListDebounced();
      },
      immediate: false,
    },
    tareaAsociada: {
      handler() {
        if (this.isRestoringState) return;
        this.saveListState();
        this.getListDebounced();
      },
      immediate: false,
    },
    esClon: {
      handler() {
        if (this.isRestoringState) return;
        this.saveListState();
        this.getListDebounced();
      },
      immediate: false,
    },
    proyectoFiltro: {
      handler() {
        if (this.isRestoringState) return;
        this.saveListState();
        this.getListDebounced();
      },
      immediate: false,
    },
    pagination: {
      handler() {
        if (this.isRestoringState) return;
        this.saveListState();
        this.getListDebounced();
      }, // Usar debounce también para paginación
      deep: true,
      immediate: false,
    },
    // Persistencia del texto del buscador (sin lanzar búsquedas)
    queryInput: {
      handler() {
        if (this.isRestoringState) return;
        this.saveListState();
      },
      immediate: false,
    },
  },
  methods: {
    // Ejecutar búsqueda explícita (botón / Enter)
    triggerSearch() {
      // Aplicar query únicamente cuando el usuario confirma búsqueda
      this.query = (this.queryInput || '').trim();

      // Resetear a primera página para evitar páginas vacías al filtrar
      if (this.pagination?.currentPage && this.pagination.currentPage !== 1) {
        this.pagination.currentPage = 1;
      }

      // Cancelar cualquier búsqueda debounced pendiente y lanzar una inmediata
      try {
        if (this.getListDebounced && typeof this.getListDebounced.cancel === 'function') {
          this.getListDebounced.cancel();
        }
      } catch (e) {
        // noop
      }

      this.saveListState();
      this.getList();
    },

    getListStateStorageKey() {
      // Key estable por ruta (y por entorno si se desea)
      return 'misepis:list-albaran:state:v1';
    },

    saveListState() {
      try {
        const payload = {
          queryInput: this.queryInput,
          query: this.query,
          selectedDate: this.selectedDate,
          fdesde: this.fdesde,
          fhasta: this.fhasta,
          sort: this.sort,
          currentView: this.currentView,
          calendarDate: this.calendarDate ? new Date(this.calendarDate).toISOString() : null,
          calendarFilterDate: this.calendarFilterDate,
          selectedDay: this.selectedDay ? new Date(this.selectedDay).toISOString() : null,
          estado: this.estado,
          tareaAsociada: this.tareaAsociada,
          esClon: this.esClon,
          proyectoFiltro: this.proyectoFiltro,
          pagination: {
            perPage: this.pagination?.perPage,
            currentPage: this.pagination?.currentPage,
          },
        };
        localStorage.setItem(this.getListStateStorageKey(), JSON.stringify(payload));
      } catch (e) {
        // noop (privacidad/limitaciones del navegador)
      }
    },

    restoreListState() {
      try {
        const raw = localStorage.getItem(this.getListStateStorageKey());
        if (!raw) return false;
        const saved = JSON.parse(raw);
        if (!saved || typeof saved !== 'object') return false;

        this.isRestoringState = true;

        // Restaurar filtros
        this.queryInput = saved.queryInput ?? this.queryInput;
        this.query = saved.query ?? this.query;
        this.selectedDate = saved.selectedDate ?? this.selectedDate;
        this.fdesde = saved.fdesde ?? this.fdesde;
        this.fhasta = saved.fhasta ?? this.fhasta;
        this.sort = Array.isArray(saved.sort) ? saved.sort : this.sort;
        this.currentView = saved.currentView ?? this.currentView;
        this.calendarFilterDate = saved.calendarFilterDate ?? this.calendarFilterDate;
        this.estado = saved.estado ?? this.estado;
        this.tareaAsociada = saved.tareaAsociada ?? this.tareaAsociada;
        this.esClon = saved.esClon ?? this.esClon;
        this.proyectoFiltro = saved.proyectoFiltro ?? this.proyectoFiltro;

        // Fechas como Date
        if (saved.calendarDate) this.calendarDate = new Date(saved.calendarDate);
        if (saved.selectedDay) this.selectedDay = new Date(saved.selectedDay);

        // Paginación
        if (saved.pagination && typeof saved.pagination === 'object') {
          if (saved.pagination.perPage) this.pagination.perPage = saved.pagination.perPage;
          if (saved.pagination.currentPage) this.pagination.currentPage = saved.pagination.currentPage;
        }

        return true;
      } catch (e) {
        return false;
      } finally {
        this.isRestoringState = false;
      }
    },

    getPageTitle() {
      if (this.currentView === 'list') {
        // Vista de listado: "Albaranes septiembre 2025 (28)" - mostrar mes completo
        const monthFormatted = this.formatCalendarMonth(this.calendarDate);
        return `Albaranes ${monthFormatted} (${this.total})`;
      } else if (this.currentView === 'calendar') {
        // Vista de calendario: "Albaranes septiembre 2025 (28)"
        const monthFormatted = this.formatCalendarMonth(this.calendarDate);
        return `Albaranes ${monthFormatted} (${this.total})`;
      }
      return 'Albaranes';
    },

    setView(view) {
      this.currentView = view;
      if (view === 'calendar') {
        // Si ya hay albaranes cargados, generar eventos inmediatamente
        if (this.albaranes && this.albaranes.length > 0) {
          this.generateCalendarEvents();
        }
        // Cargar el mes completo
        this.loadCalendarMonth();
      } else if (view === 'list') {
        // Cargar el mes completo también en vista de listado
        this.loadListMonth();
      }
    },
    
    // Cargar mes completo para vista de listado
    async loadListMonth() {
      // Limpiar filtros de día para cargar todo el mes
      this.selectedDate = '';
      this.fdesde = '';
      this.fhasta = '';
      
      // Usar calendarDate para mantener sincronización con el calendario
      const year = this.calendarDate.getFullYear();
      const month = this.calendarDate.getMonth();
      const firstDay = new Date(year, month, 1);
      const lastDay = new Date(year, month + 1, 0);
      
      // Formatear fechas para el API
      this.fdesde = moment(firstDay).format('YYYY-MM-DD');
      this.fhasta = moment(lastDay).format('YYYY-MM-DD');
      
      console.log('📅 [LIST] Cargando mes completo:', {
        mes: this.formatCalendarMonth(this.calendarDate),
        fdesde: this.fdesde,
        fhasta: this.fhasta
      });
      
      // Cargar albaranes del mes completo
      await this.getList();
    },

    async loadCalendarMonth() {
      // Limpiar filtros de día para cargar todo el mes
      this.selectedDate = '';
      this.fdesde = '';
      this.fhasta = '';
      
      // Obtener el primer y último día del mes actual
      const year = this.calendarDate.getFullYear();
      const month = this.calendarDate.getMonth();
      const firstDay = new Date(year, month, 1);
      const lastDay = new Date(year, month + 1, 0);
      
      // Formatear fechas para el API
      this.fdesde = moment(firstDay).format('YYYY-MM-DD');
      this.fhasta = moment(lastDay).format('YYYY-MM-DD');
      
      console.log('📅 [CALENDAR] Cargando mes completo:', {
        mes: this.formatCalendarMonth(this.calendarDate),
        fdesde: this.fdesde,
        fhasta: this.fhasta
      });
      
      // Cargar albaranes del mes completo
      // getList() ya genera los eventos del calendario y carga las incidencias si estamos en vista de calendario
      await this.getList();
      
      console.log('📅 [CALENDAR] Eventos generados:', {
        totalEventos: this.calendarEvents.length,
        eventos: this.calendarEvents.map(e => ({ id: e.id, title: e.title, start: e.start }))
      });
    },
    
    async refrescarListado() {
      try {
        this.loading = true;
        
        if (this.currentView === 'list') {
          // Recargar el mes completo para la vista de listado
          await this.loadListMonth();
        } else if (this.currentView === 'calendar') {
          // Recargar el mes completo para la vista de calendario
          await this.loadCalendarMonth();
        }
        
        // Intentar enlazar tareas de Keikaku a albaranes sin tarea
        await this.intentarEnlazarTareasSinTarea();
        
        this.$notify({
          type: 'success',
          message: 'Listado actualizado correctamente'
        });
      } catch (error) {
        console.error('Error al refrescar el listado:', error);
        this.$notify({
          type: 'danger',
          message: 'Error al actualizar el listado'
        });
      } finally {
        this.loading = false;
      }
    },
    
    async intentarEnlazarTareasSinTarea() {
      try {
        console.log('🔗 [ENLAZAR TAREAS] Iniciando búsqueda de albaranes sin tarea...');
        
        // Filtrar albaranes sin tarea_keikaku_id
        const albaranesSinTarea = this.albaranes.filter(albaran => {
          const tareaId = albaran.attributes?.tarea_keikaku_id || albaran.tarea_keikaku_id;
          const fechaEntrega = albaran.attributes?.fecha_entrega || albaran.fecha_entrega;
          // Solo procesar albaranes sin tarea y con fecha de entrega
          return !tareaId && fechaEntrega;
        });
        
        if (albaranesSinTarea.length === 0) {
          console.log('✅ [ENLAZAR TAREAS] No hay albaranes sin tarea para procesar');
          return;
        }
        
        console.log(`🔗 [ENLAZAR TAREAS] Encontrados ${albaranesSinTarea.length} albaranes sin tarea`);
        
        let enlazados = 0;
        let errores = 0;
        
        // Procesar cada albarán sin tarea
        for (const albaran of albaranesSinTarea) {
          try {
            const albaranId = albaran.attributes?.id || albaran.id;
            const numero = albaran.attributes?.numero || albaran.numero;
            
            console.log(`🔗 [ENLAZAR TAREAS] Intentando enlazar tarea para albarán ${numero} (ID: ${albaranId})`);
            
            const enlazado = await this.enlazarTareaAlbaran(albaranId, albaran);
            
            if (enlazado) {
              enlazados++;
              console.log(`✅ [ENLAZAR TAREAS] Tarea enlazada correctamente para albarán ${numero}`);
            }
          } catch (error) {
            errores++;
            console.error(`❌ [ENLAZAR TAREAS] Error enlazando tarea para albarán ${albaran.attributes?.numero || albaran.numero}:`, error.message);
          }
        }
        
        if (enlazados > 0) {
          console.log(`✅ [ENLAZAR TAREAS] Proceso completado: ${enlazados} tareas enlazadas, ${errores} errores`);
          
          // Recargar el listado para mostrar los cambios
          if (this.currentView === 'list') {
            await this.loadListMonth();
          } else if (this.currentView === 'calendar') {
            await this.loadCalendarMonth();
          }
          
          this.$notify({
            type: 'success',
            message: `${enlazados} tarea(s) enlazada(s) correctamente`
          });
        } else if (errores > 0) {
          console.log(`⚠️ [ENLAZAR TAREAS] No se pudieron enlazar tareas (${errores} errores)`);
        }
      } catch (error) {
        console.error('❌ [ENLAZAR TAREAS] Error en el proceso de enlace:', error);
        // No mostrar error al usuario, solo loguear
      }
    },
    
    async enlazarTareaAlbaran(albaranId, albaran) {
      try {
        // Obtener datos completos del albarán
        const albaranResponse = await axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/albaran-activos/${albaranId}?populate=*`,
          {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          }
        );
        
        const albaranCompleto = albaranResponse.data.data || albaranResponse.data;
        const fechaEntrega = albaranCompleto.attributes?.fecha_entrega || albaranCompleto.fecha_entrega;
        
        if (!fechaEntrega) {
          console.log(`⏭️ [ENLAZAR] Albarán ${albaranId} no tiene fecha_entrega, saltando`);
          return false;
        }
        
        // Obtener IdProyecto desde parte_trabajo o tarea_keikaku_data
        const parteTrabajo = albaranCompleto.attributes?.parte_trabajo || albaranCompleto.parte_trabajo;
        const tareaKeikakuData = albaranCompleto.attributes?.tarea_keikaku_data || albaranCompleto.tarea_keikaku_data;
        
        let idProyecto = null;
        
        // Intentar obtener desde parte_trabajo primero
        if (parteTrabajo && parteTrabajo.IdProyecto) {
          idProyecto = parteTrabajo.IdProyecto;
        }
        
        // Si no está en parte_trabajo, intentar desde tarea_keikaku_data
        if (!idProyecto && tareaKeikakuData) {
          idProyecto = tareaKeikakuData.Properties?.IdProyecto?.Value || 
                       tareaKeikakuData.IdProyecto?.Value ||
                       tareaKeikakuData.IdProyecto;
        }
        
        if (!idProyecto) {
          console.log(`⏭️ [ENLAZAR] Albarán ${albaranId} no tiene IdProyecto disponible, saltando`);
          return false;
        }
        
        // Buscar tarea en Keikaku
        const axiosInstance = axios.create({
          headers: {
            'Accept': undefined,
            'Content-Type': undefined
          }
        });
        
        const fechaInicioFormato = moment(fechaEntrega).format('YYYY-MM-DD');
        
        const keikakuQueryParams = new URLSearchParams({
          filter: `FLX_Pers_Tareas.IdProyecto='${idProyecto}'`,
          page: '0',
          pageSize: '500',
          orderBy: 'IdTarea desc',
          access_token: KEIKAKU_ACCESS_TOKEN
        }).toString();
        
        const keikakuConfig = {
          method: 'get',
          maxBodyLength: Infinity,
          url: `${KEIKAKU_API_BASE_URL}/list/Planificador_Equipo_Movil?${keikakuQueryParams}`,
          headers: {}
        };
        
        const keikakuResponse = await axiosInstance.request(keikakuConfig);
        const tareasKeikaku = Array.isArray(keikakuResponse.data) ? keikakuResponse.data : [];
        
        if (tareasKeikaku.length === 0) {
          console.log(`⏭️ [ENLAZAR] No se encontraron tareas para proyecto ${idProyecto} en fecha ${fechaInicioFormato}`);
          return false;
        }
        
        // Filtrar por fecha_inicio
        const tareasFiltradas = tareasKeikaku.filter(tarea => {
          const fechaInicioTarea = tarea.FechaInicio;
          if (!fechaInicioTarea) return false;
          return moment(fechaInicioTarea).format('YYYY-MM-DD') === fechaInicioFormato;
        });
        
        if (tareasFiltradas.length === 0) {
          console.log(`⏭️ [ENLAZAR] No se encontraron tareas para proyecto ${idProyecto} en fecha ${fechaInicioFormato} (${tareasKeikaku.length} tareas encontradas en el proyecto)`);
          return false;
        }
        
        // Tomar la primera tarea encontrada
        const tareaEncontrada = tareasFiltradas[0];
        const idTarea = tareaEncontrada.IdTarea;
        
        console.log(`✅ [ENLAZAR] Tarea encontrada: ${idTarea} para albarán ${albaranId}`);
        
        // Obtener los detalles completos de la tarea
        const tareaDetalleConfig = {
          method: 'get',
          maxBodyLength: Infinity,
          url: `${KEIKAKU_API_BASE_URL}/object/Planificador_Equipo_Movil/${idTarea}?access_token=${KEIKAKU_ACCESS_TOKEN}`,
          headers: {}
        };
        
        const tareaDetalleResponse = await axiosInstance.request(tareaDetalleConfig);
        const tareaData = tareaDetalleResponse.data.Properties;
        
        // Obtener el parte de trabajo si existe IdParte
        let parteTrabajoNuevo = null;
        let esFacturable = false;
        const idParte = tareaEncontrada.IdParte || tareaData.IdParte?.Value;
        
        if (idParte) {
          const parteQueryParams = new URLSearchParams({
            filter: `Partes.IdParte=${idParte}`,
            page: '0',
            pageSize: '5000',
            orderBy: 'IdParte desc',
            access_token: SAT_ACCESS_TOKEN
          }).toString();
          
          const parteConfig = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${SAT_API_BASE_URL}/list/sat_Parte?${parteQueryParams}`,
            headers: {}
          };
          
          const parteResponse = await axiosInstance.request(parteConfig);
          
          if (parteResponse.data && parteResponse.data.length > 0) {
            parteTrabajoNuevo = parteResponse.data[0];
            esFacturable = parteTrabajoNuevo.p_TareaFacturacion === 4 || parteTrabajoNuevo.p_TareaFacturacion === 5;
          }
        }
        
        // Actualizar el albarán con tarea_keikaku_id, tarea_keikaku_data y parte_trabajo
        const updatePayload = {
          data: {
            tarea_keikaku_id: idTarea,
            tarea_keikaku_data: tareaData
          }
        };
        
        if (parteTrabajoNuevo) {
          updatePayload.data.parte_trabajo = parteTrabajoNuevo;
          updatePayload.data.es_facturable = esFacturable;
        }
        
        await axios.put(
          `${process.env.VUE_APP_API_BASE_URL}/albaran-activos/${albaranId}`,
          updatePayload,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          }
        );
        
        console.log(`✅ [ENLAZAR] Albarán ${albaranId} actualizado con tarea ${idTarea}`);
        return true;
        
      } catch (error) {
        console.error(`❌ [ENLAZAR] Error enlazando tarea para albarán ${albaranId}:`, error);
        return false;
      }
    },

    generateCalendarEvents() {
      this.calendarEvents = this.albaranes.map(albaran => {
        // Manejar ambas estructuras: endpoint estándar (attributes) y endpoint específico (directo)
        const numero = albaran.attributes?.numero || albaran.numero;
        const titulo = albaran.attributes?.titulo || albaran.titulo;
        const cliente = albaran.attributes?.cliente || albaran.cliente;
        const fechaEntrega = albaran.attributes?.fecha_entrega || albaran.fecha_entrega;
        const estado = albaran.attributes?.estado || albaran.estado;
        const responsable = albaran.attributes?.users_permissions_user || albaran.users_permissions_user;
        const materiales = albaran.attributes?.albaran_activo_materials || albaran.albaran_activo_materials;
        
        // Generar resumen del material
        const resumenMaterial = this.generarResumenMaterial(materiales);
        
        // Generar título completo con más información
        const tituloCompleto = this.generarTituloCompleto(numero, titulo, estado, responsable, resumenMaterial);
        
        // Determinar el color: amarillo si necesita atención, verde en caso contrario
        const backgroundColor = this.getAlbaranColor(albaran);
        
        return {
          id: albaran.id,
          title: tituloCompleto,
          start: fechaEntrega,
          end: fechaEntrega,
          backgroundColor: backgroundColor,
          borderColor: backgroundColor,
          textColor: '#ffffff',
          extendedProps: {
            albaran: albaran
          }
        };
      });
    },

    generarResumenMaterial(materiales) {
      if (!materiales || !Array.isArray(materiales) || materiales.length === 0) {
        return 'Sin materiales';
      }
      
      const totalMateriales = materiales.length;
      // Normalizar: "asignado" se convierte a "entregado" (unificación de estados)
      const materialesEntregados = materiales.filter(m => {
        const estado = m.attributes?.estado || m.estado;
        return estado === 'entregado' || estado === 'asignado';
      }).length;
      const materialesPendientes = materiales.filter(m => {
        const estado = m.attributes?.estado || m.estado;
        return estado === 'pendiente_aceptar';
      }).length;
      const materialesRechazados = materiales.filter(m => {
        const estado = m.attributes?.estado || m.estado;
        return estado === 'rechazado';
      }).length;
      
      if (totalMateriales === 1) {
        const material = materiales[0];
        let estado = material.attributes?.estado || material.estado;
        // Normalizar: "asignado" se muestra como "entregado"
        if (estado === 'asignado') {
          estado = 'entregado';
        }
        return `${material.descripcion || 'Material'} (${estado})`;
      } else {
        return `${totalMateriales} materiales: ${materialesEntregados} entregados, ${materialesPendientes} pendientes, ${materialesRechazados} rechazados`;
      }
    },

    generarTituloCompleto(numero, titulo, estado, responsable, resumenMaterial) {
      let tituloCompleto = numero;
      
      // Agregar título si existe
      if (titulo) {
        tituloCompleto += ` - ${titulo}`;
      }
      
      // Agregar estado (en listado usar formato corto, p. ej. MAT. ABANDONADO)
      const estadoTexto = this.formatEstado(estado);
      tituloCompleto += ` [${estadoTexto}]`;
      
      // Agregar responsable si existe
      if (responsable && responsable.nombre) {
        const nombreCompleto = `${responsable.nombre} ${responsable.apellidos || ''}`.trim();
        tituloCompleto += ` - ${nombreCompleto}`;
      }
      
      // Agregar resumen de material
      tituloCompleto += ` - ${resumenMaterial}`;
      
      return tituloCompleto;
    },

    getEstadoTexto(estado) {
      return getEstadoTextoUtil(estado);
    },

    getEventNumero(event) {
      const albaran = event.extendedProps.albaran;
      const numero = albaran.attributes?.numero || albaran.numero;
      
      // Si es un albarán clonado (empieza con "CL") y tiene tarea asociada, añadir el ID de tarea
      if (numero && numero.startsWith('CL')) {
        const tareaId = albaran.attributes?.tarea_keikaku_id || albaran.tarea_keikaku_id;
        if (tareaId) {
          return `${numero}-T${tareaId}`;
        }
      }
      
      return numero;
    },

    getEventTitulo(event) {
      const albaran = event.extendedProps.albaran;
      return albaran.attributes?.titulo || albaran.titulo || 'Sin título';
    },

    getEventEstado(event) {
      const albaran = event.extendedProps.albaran;
      const estadoBackend = this.getEstadoAlbaran(albaran);
      return this.formatEstado(estadoBackend);
    },

    getEventEstadoBadgeColor(event) {
      const albaran = event.extendedProps.albaran;
      const estadoBackend = this.getEstadoAlbaran(albaran);
      // Usar los colores centralizados de estadoColors.js para el badge
      const color = getEstadoColorUtil(estadoBackend);
      // Si el color es transparente, usar el color transparente original
      if (color === 'transparent') {
        return 'rgba(255, 255, 255, 0.3)';
      }
      return color || 'rgba(255, 255, 255, 0.3)';
    },

    getEventResponsable(event) {
      const albaran = event.extendedProps.albaran;
      const responsable = albaran.attributes?.users_permissions_user || albaran.users_permissions_user;
      if (responsable && responsable.nombre) {
        return `${responsable.nombre} ${responsable.apellidos || ''}`.trim();
      }
      return ''; // No mostrar "Sin asignar" porque ya aparece en el estado
    },

    getEventMaterial(event) {
      const albaran = event.extendedProps.albaran;
      const materiales = albaran.attributes?.albaran_activo_materials || albaran.albaran_activo_materials;
      
      if (!materiales || !Array.isArray(materiales) || materiales.length === 0) {
        return 'Sin materiales';
      }
      
      const totalMateriales = materiales.length;
      return `${totalMateriales} ${totalMateriales === 1 ? 'material' : 'materiales'}`;
    },

    getEventTarea(event) {
      const albaran = event.extendedProps.albaran;
      const tareaId = albaran.attributes?.tarea_keikaku_id || albaran.tarea_keikaku_id;
      return tareaId ? tareaId.toString() : null;
    },

    getEventParte(event) {
      const albaran = event.extendedProps.albaran;
      const parteTrabajo = albaran.attributes?.parte_trabajo || albaran.parte_trabajo;
      
      if (!parteTrabajo || typeof parteTrabajo !== 'object') {
        return null;
      }
      
      // Extraer IdParte del objeto parte_trabajo (misma lógica que ViewAlbaranPage)
      const idParte = parteTrabajo.IdParte;
      
      return idParte ? idParte.toString() : null;
    },

    getEventEsFacturable(event) {
      const albaran = event.extendedProps.albaran;
      return albaran.attributes?.es_facturable || albaran.es_facturable || false;
    },

    getEstadoColor(estado) {
      return getEstadoColorUtil(estado);
    },
    
    // Determinar si un albarán necesita atención (amarillo)
    necesitaAtencion(albaran) {
      // Manejar ambas estructuras: endpoint estándar (attributes) y endpoint específico (directo)
      const estado = albaran.attributes?.estado || albaran.estado;
      const fechaEntrega = albaran.attributes?.fecha_entrega || albaran.fecha_entrega;
      const responsable = albaran.attributes?.users_permissions_user || albaran.users_permissions_user;
      const materiales = albaran.attributes?.albaran_activo_materials || albaran.albaran_activo_materials;
      
      // 1. Verificar si está pendiente de asignar
      if (estado === 'pendiente_asignar' || !responsable) {
        return true;
      }
      
      // 2. Verificar si es anterior a hoy y no está cerrado
      if (fechaEntrega) {
        const fechaEntregaDate = new Date(fechaEntrega);
        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0);
        fechaEntregaDate.setHours(0, 0, 0, 0);
        
        if (fechaEntregaDate < hoy && estado !== 'cerrado') {
          return true;
        }
      }
      
      return false;
    },
    
    // Obtener color del albarán para el calendario según su estado
    getAlbaranColor(albaran) {
      const estado = this.getEstadoAlbaran(albaran);
      const fechaEntrega = albaran.attributes?.fecha_entrega || albaran.fecha_entrega;
      
      // Si el estado no es cerrado y la fecha de entrega es anterior a hoy, mostrar en amarillo
      const estadoCerrado = estado === 'cerrado' || estado === 'cerrado_sin_tarea';
      if (!estadoCerrado && fechaEntrega) {
        const fechaEntregaDate = new Date(fechaEntrega);
        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0); // Resetear horas para comparar solo fechas
        fechaEntregaDate.setHours(0, 0, 0, 0);
        
        if (fechaEntregaDate < hoy) {
          return '#F1C40F'; // Amarillo para albaranes vencidos
        }
      }
      
      // Amarillo: PREPARACIÓN (pendiente_asignar), ASIGNADO, REVISAR DEVOLUCIÓN, INCIDENCIA
      // Nota: Incidencia se muestra en amarillo en el calendario, pero el badge mostrará rojo
      if (estado === 'pendiente_asignar' || estado === 'asignado' || estado === 'pendiente_aceptar_devolucion' || estado === 'incidencia') {
        return '#F1C40F'; // Amarillo
      }
      
      // Verde: ENTREGADO, DEVUELTO
      if (estado === 'entregado' || estado === 'devuelto') {
        return '#2ECC71'; // Verde
      }
      
      // Cerrado: Azul si es facturable, Verde si no es facturable
      if (estadoCerrado) {
        const esFacturable = albaran.attributes?.es_facturable || albaran.es_facturable;
        if (esFacturable) {
          return '#3498DB'; // Azul si es facturable
        } else {
          return '#2ECC71'; // Verde si no es facturable
        }
      }
      
      // Por defecto amarillo
      return '#F1C40F';
    },
    
    // Formatear el día del albarán
    formatDiaAlbaran(albaran) {
      const fechaEntrega = albaran.attributes?.fecha_entrega || albaran.fecha_entrega;
      if (!fechaEntrega) return '-';
      
      // Formato: "Lun 05/11" o "Mar 06/11"
      return moment(fechaEntrega).format('ddd DD/MM');
    },

    getDuplicadosHoyCount(row) {
      const tareaId = row.attributes?.tarea_keikaku_id ?? row.tarea_keikaku_id;
      const fechaEntrega = row.attributes?.fecha_entrega || row.fecha_entrega;
      if (!tareaId || !fechaEntrega) return 0;
      const ymd = moment(fechaEntrega).format('YYYY-MM-DD');
      if (ymd !== this.todayYMD) return 0;
      return this.duplicadosTareaHoy[String(tareaId)] || 0;
    },
    
    sortByFechaEntrega(a, b) {
      const fechaA = a.attributes?.fecha_entrega || a.fecha_entrega;
      const fechaB = b.attributes?.fecha_entrega || b.fecha_entrega;
      
      if (!fechaA && !fechaB) return 0;
      if (!fechaA) return 1; // Sin fecha al final
      if (!fechaB) return -1; // Sin fecha al final
      
      const dateA = new Date(fechaA);
      const dateB = new Date(fechaB);
      
      // Ordenar descendente (más reciente primero)
      return dateB - dateA;
    },
    
    // Obtener clase CSS de la fila según el estado del albarán
    getRowClass({ row }) {
      const estado = this.getEstadoAlbaran(row);
      const dupCount = this.getDuplicadosHoyCount(row);
      
      // Cerrado: Azul si es facturable, Verde si no es facturable
      if (estado === 'cerrado' || estado === 'cerrado_sin_tarea') {
        const esFacturable = row.attributes?.es_facturable || row.es_facturable;
        if (esFacturable) {
          return dupCount > 1 ? 'albaran-cerrado albaran-duplicado-keikaku-hoy' : 'albaran-cerrado'; // Azul si es facturable
        } else {
          return dupCount > 1 ? 'albaran-cerrado-no-facturable albaran-duplicado-keikaku-hoy' : 'albaran-cerrado-no-facturable'; // Verde si no es facturable
        }
      }
      
      // Verde: ENTREGADO, DEVUELTO
      if (estado === 'entregado' || estado === 'devuelto') {
        return dupCount > 1 ? 'albaran-ok albaran-duplicado-keikaku-hoy' : 'albaran-ok'; // Verde
      }
      
      // Amarillo: PREPARACIÓN, ASIGNADO, REVISAR DEVOLUCIÓN, INCIDENCIA
      // Nota: Incidencia se muestra en amarillo en la fila, pero el badge mostrará rojo
      if (estado === 'pendiente_asignar' || estado === 'asignado' || estado === 'pendiente_aceptar_devolucion' || estado === 'incidencia') {
        return dupCount > 1 ? 'albaran-necesita-atencion albaran-duplicado-keikaku-hoy' : 'albaran-necesita-atencion'; // Amarillo
      }
      
      // Por defecto amarillo
      return dupCount > 1 ? 'albaran-necesita-atencion albaran-duplicado-keikaku-hoy' : 'albaran-necesita-atencion';
    },
    

    getEstadoBadgeClass(estado) {
      return getEstadoBadgeClassUtil(estado);
    },

    formatCalendarMonth(date) {
      const months = [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
      ];
      return `${months[date.getMonth()]} ${date.getFullYear()}`;
    },

    previousMonth() {
      this.calendarDate = new Date(this.calendarDate.getFullYear(), this.calendarDate.getMonth() - 1, 1);
      if (this.currentView === 'calendar') {
        this.loadCalendarMonth();
      } else if (this.currentView === 'list') {
        this.loadListMonth();
      }
    },

    nextMonth() {
      this.calendarDate = new Date(this.calendarDate.getFullYear(), this.calendarDate.getMonth() + 1, 1);
      if (this.currentView === 'calendar') {
        this.loadCalendarMonth();
      } else if (this.currentView === 'list') {
        this.loadListMonth();
      }
    },

    today() {
      this.calendarDate = new Date();
      if (this.currentView === 'calendar') {
        this.loadCalendarMonth();
      } else if (this.currentView === 'list') {
        this.loadListMonth();
      }
    },

    filterByDate() {
      if (this.calendarFilterDate) {
        // Filtrar albaranes por la fecha seleccionada
        const selectedDate = moment(this.calendarFilterDate).format('YYYY-MM-DD');
        this.fdesde = selectedDate;
        this.fhasta = selectedDate;
        this.selectedDate = this.calendarFilterDate;
        
        // Ir al mes de la fecha seleccionada
        this.calendarDate = new Date(this.calendarFilterDate);
        
        // Aplicar filtros
        this.getListDebounced();
      } else {
        // Limpiar filtros
        this.fdesde = '';
        this.fhasta = '';
        this.selectedDate = '';
        this.getListDebounced();
      }
    },

    // Métodos para navegación por días en vista lista
    formatSelectedDay() {
      return moment(this.selectedDay).format('dddd, DD [de] MMMM [de] YYYY');
    },

    previousDay() {
      const newDate = new Date(this.selectedDay);
      newDate.setDate(newDate.getDate() - 1);
      this.selectedDay = newDate;
      this.applyDayFilter();
    },

    nextDay() {
      const newDate = new Date(this.selectedDay);
      newDate.setDate(newDate.getDate() + 1);
      this.selectedDay = newDate;
      this.applyDayFilter();
    },

    goToToday() {
      this.selectedDay = new Date();
      this.applyDayFilter();
    },

    applyDayFilter() {
      // Aplicar filtro por el día seleccionado
      const dayString = moment(this.selectedDay).format('YYYY-MM-DD');
      
      // Limpiar otros filtros de fecha para evitar conflictos
      this.selectedDate = '';
      
      // Establecer el rango de fechas para el día específico
      this.fdesde = dayString;
      this.fhasta = dayString;
      
      console.log('🔍 [FILTER] Aplicando filtro por día:', {
        selectedDay: this.selectedDay,
        dayString: dayString,
        fdesde: this.fdesde,
        fhasta: this.fhasta
      });
      
      // Aplicar filtros
      this.getListDebounced();
    },

    getListDebounced: debounce(function () {
      // No ejecutar si es la carga inicial (ya se ejecuta en mounted)
      if (this.isInitialLoad) {
        console.log('⏸️ [GETLIST] Carga inicial en progreso, saltando llamada debounced');
        return;
      }
      this.getList();
    }, 300),

    async getList() {
      // Evitar llamadas duplicadas si ya se está cargando
      if (this.loading) {
        console.log('⏸️ [GETLIST] Ya hay una carga en progreso, saltando llamada duplicada');
        return;
      }
      
      this.loading = true;
      this.isInitialLoad = false; // Marcar que ya no es la carga inicial
      
      try {
        // Obtener el perfil del usuario y sus empresas
        await this.$store.dispatch("profile/me");
        let profile = await this.$store.getters["profile/me"];

        // Preparar parámetros para la consulta
        const params = {
          // Asegurar que siempre se ordene por fecha_entrega descendente (más reciente primero)
          sort: this.sort && this.sort.length > 0 ? this.sort : ["fecha_entrega:desc"],
          query: this.query,
          estado: this.estado,
          tareaAsociada: this.tareaAsociada,
          esClon: this.esClon,
          selectedDate: this.selectedDate,
          fdesde: this.fdesde,
          fhasta: this.fhasta,
          pagination: {
            page: this.pagination.currentPage,
            pageSize: this.pagination.perPage
          }
        };

        // Guardar estado de filtros/paginación cada vez que lanzamos una carga
        this.saveListState();

        // Si hay un filtro por proyecto activo, NO limitar por fecha en el backend
        // Esto permite cargar todos los albaranes del proyecto, no solo los del mes actual
        const tieneFiltroProyecto = this.proyectoFiltro && this.proyectoFiltro !== "Todos";

        // Para la vista de calendario o listado, cargar todo el mes
        if (this.currentView === 'calendar') {
          // Si hay filtro por proyecto, no limitar por fecha en el backend
          if (!tieneFiltroProyecto) {
          params.fdesde = this.fdesde;
          params.fhasta = this.fhasta;
          } else {
            // Cuando hay filtro por proyecto, no enviar fechas al backend
            params.fdesde = '';
            params.fhasta = '';
          }
          params.selectedDate = '';
          
          console.log('📅 [GETLIST] Vista calendario - cargando mes completo:', {
            mes: this.formatCalendarMonth(this.calendarDate),
            fdesde: params.fdesde,
            fhasta: params.fhasta,
            tieneFiltroProyecto: tieneFiltroProyecto
          });
        } else if (this.currentView === 'list') {
          // Si hay filtro por proyecto, no limitar por fecha en el backend
          if (!tieneFiltroProyecto) {
          params.fdesde = this.fdesde;
          params.fhasta = this.fhasta;
          } else {
            // Cuando hay filtro por proyecto, no enviar fechas al backend
            params.fdesde = '';
            params.fhasta = '';
          }
          params.selectedDate = '';
          
          console.log('📅 [GETLIST] Vista listado - cargando mes completo:', {
            mes: this.formatCalendarMonth(this.calendarDate),
            fdesde: params.fdesde,
            fhasta: params.fhasta,
            tieneFiltroProyecto: tieneFiltroProyecto
          });
        }

        console.log('🔍 [GETLIST] Parámetros enviados al store:', {
          params: params,
          query: params.query,
          queryType: typeof params.query,
          queryLength: params.query ? params.query.length : 0,
          currentView: this.currentView,
          selectedDay: this.selectedDay
        });

        // Obtener lista de albaranes
        const response = await this.$store.dispatch("albaranes/list", params);
        
        let albaranes = this.$store.getters["albaranes/list"];
        this.total = this.$store.getters["albaranes/listTotal"];
        
        // Ordenar por fecha_entrega descendente (más reciente primero) como fallback
        // Esto asegura que siempre estén ordenados correctamente aunque el backend no lo haga
        albaranes = albaranes.sort((a, b) => {
          const fechaA = a.attributes?.fecha_entrega || a.fecha_entrega;
          const fechaB = b.attributes?.fecha_entrega || b.fecha_entrega;
          
          if (!fechaA && !fechaB) return 0;
          if (!fechaA) return 1; // Sin fecha al final
          if (!fechaB) return -1; // Sin fecha al final
          
          const dateA = new Date(fechaA);
          const dateB = new Date(fechaB);
          
          // Ordenar descendente (más reciente primero)
          return dateB - dateA;
        });
        
        // NO aplicar filtro de estado aquí - se aplicará después de cargar los materiales
        // El filtro se aplicará en el computed o después de cargar todos los datos

        // El filtro de estado ya se aplica en el backend a través del store
        // Solo verificamos que los resultados coincidan con el filtro seleccionado
        // Si hay discrepancias, aplicamos un filtro adicional en el frontend
        if (this.estado && this.estado !== "Todos") {
          const albaranesFiltrados = albaranes.filter(albaran => {
            const estadoBackend = this.getEstadoAlbaran(albaran);
            const estadoFormateado = this.formatEstado(estadoBackend);
            return estadoFormateado === this.estado;
          });
          
          // Si el backend no filtró correctamente, usar el filtro del frontend
          if (albaranesFiltrados.length !== albaranes.length) {
            console.log('⚠️ [FILTRO] El backend no filtró correctamente, aplicando filtro en frontend');
            albaranes = albaranesFiltrados;
          }
        }
        
        // Actualizar lista de proyectos disponibles (antes de filtrar)
        // Usar todos los albaranes cargados, no solo los filtrados
        this.updateProyectosDisponibles(albaranes);
        
        // Aplicar filtro por proyecto
        if (this.proyectoFiltro && this.proyectoFiltro !== "Todos") {
          albaranes = albaranes.filter(albaran => {
            const proyecto = this.getProyectoFromAlbaran(albaran);
            return proyecto === this.proyectoFiltro;
          });
          
          // Si hay filtro por proyecto, también filtrar por fecha en el frontend
          // para mostrar solo el mes actual en el calendario/listado
          if (this.fdesde && this.fhasta) {
            const fechaDesde = new Date(this.fdesde);
            const fechaHasta = new Date(this.fhasta);
            fechaHasta.setHours(23, 59, 59, 999); // Incluir todo el día
            
            albaranes = albaranes.filter(albaran => {
              const fechaEntrega = albaran.attributes?.fecha_entrega || albaran.fecha_entrega;
              if (!fechaEntrega) return false;
              
              const fechaAlbaran = new Date(fechaEntrega);
              return fechaAlbaran >= fechaDesde && fechaAlbaran <= fechaHasta;
            });
          }
        }
        
        // IMPORTANTE: Recalcular el estado de cada albarán basado en sus materiales
        // Esto asegura que los estados y colores se actualicen correctamente
        albaranes = albaranes.map(albaran => {
          // Calcular el nuevo estado basado en los materiales
          const nuevoEstado = this.calcularEstadoAlbaran(albaran);
          
          // Si se calculó un nuevo estado diferente al del backend, actualizarlo
          if (nuevoEstado) {
            const estadoBackend = albaran.attributes?.estado || albaran.estado;
            
            // Solo actualizar si el estado calculado es diferente y el albarán no está en estado manual
            if (nuevoEstado !== estadoBackend && 
                estadoBackend !== 'cerrado' && 
                estadoBackend !== 'cerrado_sin_tarea' &&
                estadoBackend !== 'material_abandonado') {
              
              // Actualizar el estado en el objeto del albarán
              if (albaran.attributes) {
                albaran.attributes.estado = nuevoEstado;
              } else {
                albaran.estado = nuevoEstado;
              }
              
              console.log(`🔄 [ACTUALIZAR ESTADO] Albarán ${albaran.attributes?.numero || albaran.numero}: ${estadoBackend} → ${nuevoEstado}`);
            }
          }
          
          return albaran;
        });
        
        // IMPORTANTE: Asignar albaranes ANTES de generar eventos del calendario
        this.albaranes = albaranes;
        
        // Forzar actualización de la vista para que los colores se actualicen
        this.$nextTick(() => {
          // Generar eventos del calendario si estamos en vista de calendario
          // Esto debe hacerse DESPUÉS de asignar this.albaranes para que use los datos correctos
          if (this.currentView === 'calendar') {
            this.generateCalendarEvents();
          }
          
          // Forzar actualización de la vista para que los colores se reflejen
          this.$forceUpdate();
        });

        // Usar estadísticas del endpoint si están disponibles
        if (response && response.stats) {
          console.log('📊 [GETLIST] Usando estadísticas del endpoint:', response.stats);
          
          // Estadísticas básicas de albaranes
          this.totalPendientesAsignar = response.stats.pendiente_asignar || 0;
          this.totalAsignados = response.stats.asignado || 0;
          this.totalCerrados = response.stats.cerrado || 0;
          this.totalClones = response.stats.clones || 0;
          this.totalCerradosSinTarea = response.stats.cerrado_sin_tarea || 0;
          this.totalAlbaranesConTarea = response.stats.albaranesConTarea || 0;
          this.totalAlbaranesSinTarea = response.stats.albaranesSinTarea || 0;
          
          // Estadísticas específicas del mes (si están disponibles)
          if (response.stats.mes) {
            console.log('📅 [GETLIST] Estadísticas del mes:', {
              mes: response.stats.mes,
              nombreMes: response.stats.nombreMes,
              diasDelMes: response.stats.diasDelMes,
              albaranesPorDia: response.stats.albaranesPorDia
            });
          }
        } else {
          // Fallback: calcular totales manualmente si no hay estadísticas
          console.log('📊 [GETLIST] Calculando estadísticas manualmente (fallback)');
          this.totalPendientesAsignar = this.albaranes.filter(a => {
            const estado = a.attributes?.estado || a.estado;
            return estado === "pendiente_asignar";
          }).length;
          this.totalAsignados = this.albaranes.filter(a => {
            const estado = a.attributes?.estado || a.estado;
            return estado === "asignado";
          }).length;
          this.totalCerrados = this.albaranes.filter(a => {
            const estado = a.attributes?.estado || a.estado;
            return estado === "cerrado";
          }).length;
          this.totalClones = this.albaranes.filter(a => {
            const esClon = a.attributes?.es_clon || a.es_clon;
            return esClon === true;
          }).length;
          this.totalCerradosSinTarea = this.albaranes.filter(a => {
            const estado = a.attributes?.estado || a.estado;
            return estado === "cerrado_sin_tarea";
          }).length;
          this.totalAlbaranesConTarea = this.albaranes.filter(a => {
            const tareaId = a.attributes?.tarea_keikaku_id || a.tarea_keikaku_id;
            return tareaId;
          }).length;
          this.totalAlbaranesSinTarea = this.albaranes.filter(a => {
            const tareaId = a.attributes?.tarea_keikaku_id || a.tarea_keikaku_id;
            return !tareaId;
          }).length;
        }

      } catch (error) {
        console.error("Error fetching albaranes:", error);
        this.$notify({
          type: "danger",
          message: "Error al cargar los albaranes"
        });
      } finally {
        this.loading = false;
      }
    },

    formatDate(date) {
      return date ? moment(date).format("DD/MM/YYYY HH:mm") : "-";
    },

    formatEstado(estado) {
      const estados = {
        pendiente_asignar: "Sin Asignar",
        asignado: "Asignado",
        entregado: "Entregado",
        devuelto: "Devuelto",
        cerrado: "Cerrado",
        cerrado_sin_tarea: "Cerrado sin tarea",
        pendiente_aceptar_devolucion: "Revisar Devolución",
        incidencia: "Incidencia",
        material_abandonado: "MAT. ABANDONADO"
      };
      return estados[estado] || estado;
    },

    // Obtener el estado del albarán desde el backend (fuente de verdad)
    getEstadoAlbaran(albaran) {
      if (!albaran) return null;
      // Priorizar el estado del backend
      return albaran.attributes?.estado || albaran.estado || null;
    },
    
    // Obtener el proyecto de un albarán
    getProyectoFromAlbaran(albaran) {
      if (!albaran) return null;
      
      // Primero intentar desde parte_trabajo (más confiable cuando existe)
      const parteTrabajo = albaran.attributes?.parte_trabajo || albaran.parte_trabajo;
      if (parteTrabajo) {
        const proyecto = parteTrabajo.IdProyecto_flxtext || parteTrabajo.Proyecto;
        if (proyecto) return proyecto;
      }
      
      // Si no está en parte_trabajo, intentar desde tarea_keikaku_data
      // Esto es importante cuando hay tarea pero aún no se ha creado el parte
      const tareaKeikakuData = albaran.attributes?.tarea_keikaku_data || albaran.tarea_keikaku_data;
      if (tareaKeikakuData) {
        // Buscar en todas las posibles ubicaciones dentro de tarea_keikaku_data
        const proyecto = 
          // Properties.IdProyecto_flxtext (nombre del proyecto) - múltiples formatos
          tareaKeikakuData.Properties?.IdProyecto_flxtext?.Value ||
          tareaKeikakuData.Properties?.IdProyecto_flxtext?.Text ||
          tareaKeikakuData.Properties?.IdProyecto_flxtext?.TextVa ||
          tareaKeikakuData.Properties?.IdProyecto_flxtext ||
          // Properties.Proyecto (nombre alternativo) - múltiples formatos
          tareaKeikakuData.Properties?.Proyecto?.Value ||
          tareaKeikakuData.Properties?.Proyecto?.Text ||
          tareaKeikakuData.Properties?.Proyecto?.TextVa ||
          tareaKeikakuData.Properties?.Proyecto ||
          // IdProyecto_flxtext directo - múltiples formatos
          tareaKeikakuData.IdProyecto_flxtext?.Value ||
          tareaKeikakuData.IdProyecto_flxtext?.Text ||
          tareaKeikakuData.IdProyecto_flxtext?.TextVa ||
          tareaKeikakuData.IdProyecto_flxtext ||
          // Proyecto directo - múltiples formatos
          tareaKeikakuData.Proyecto?.Value ||
          tareaKeikakuData.Proyecto?.Text ||
          tareaKeikakuData.Proyecto?.TextVa ||
          tareaKeikakuData.Proyecto;
        
        if (proyecto) return proyecto;
        
        // Si hay tarea_keikaku_data pero no se encontró proyecto, log para debug
        const tareaId = albaran.attributes?.tarea_keikaku_id || albaran.tarea_keikaku_id;
        if (tareaId) {
          console.warn('⚠️ [PROYECTO] Albarán con tarea pero sin proyecto encontrado en tarea_keikaku_data:', {
            albaranId: albaran.id || albaran.attributes?.id,
            numero: albaran.numero || albaran.attributes?.numero,
            tareaId: tareaId,
            tieneParteTrabajo: !!parteTrabajo,
            estructuraTareaData: tareaKeikakuData ? Object.keys(tareaKeikakuData) : null,
            propertiesKeys: tareaKeikakuData?.Properties ? Object.keys(tareaKeikakuData.Properties) : null
          });
        }
      }
      
      return null;
    },
    
    // Actualizar la lista de proyectos disponibles
    updateProyectosDisponibles(albaranes) {
      const proyectosSet = new Set();
      
      albaranes.forEach(albaran => {
        const proyecto = this.getProyectoFromAlbaran(albaran);
        if (proyecto) {
          proyectosSet.add(proyecto);
        }
      });
      
      // Ordenar alfabéticamente
      this.proyectosDisponibles = Array.from(proyectosSet).sort();
    },

    // Calcular el estado del albarán según las reglas de negocio (igual que en ViewAlbaranPage)
    // Se mantiene para casos especiales, pero normalmente usamos getEstadoAlbaran()
    calcularEstadoAlbaran(albaran) {
      if (!albaran) return null;
      
      // Estados manuales: mantener estado (no recalcular desde materiales)
      const estadoActual = albaran.attributes?.estado || albaran.estado;
      if (estadoActual === 'cerrado' || estadoActual === 'cerrado_sin_tarea' || estadoActual === 'material_abandonado') {
        return estadoActual;
      }
      
      // Verificar si tiene jefe de equipo asignado
      const tieneJefeEquipo = albaran.attributes?.users_permissions_user || albaran.users_permissions_user;
      
      // Si no tiene jefe de equipo asignado → pendiente_asignar
      if (!tieneJefeEquipo) {
        return 'pendiente_asignar';
      }
      
      // Obtener materiales - puede estar en diferentes estructuras según el endpoint
      let materiales = [];
      if (albaran.attributes?.albaran_activo_materials) {
        materiales = albaran.attributes.albaran_activo_materials;
      } else if (albaran.albaran_activo_materials) {
        materiales = albaran.albaran_activo_materials;
      } else if (albaran.attributes?.albaranActivoMaterials) {
        materiales = albaran.attributes.albaranActivoMaterials;
      }
      
      // Si no hay materiales pero tiene jefe, mantener el estado actual o asignado
      if (!materiales || materiales.length === 0) {
        return estadoActual || 'asignado';
      }

      // Obtener todos los estados de los materiales
      const estadosMateriales = materiales
        .map(m => {
          // Manejar diferentes estructuras de datos
          let estado = null;
          if (m.attributes) {
            estado = m.attributes.estado || m.estado;
          } else {
            estado = m.estado;
          }
          // Normalizar: "asignado" a nivel de material se convierte a "entregado" (unificación)
          if (estado === 'asignado') {
            estado = 'entregado';
          }
          return estado;
        })
        .filter(estado => estado && estado !== null && estado !== undefined);

      // Debug: Log para verificar el cálculo
      const albaranId = albaran.id || albaran.attributes?.id;
      if (albaranId === 293 || albaranId === 296) {
        console.log(`🔍 [LISTADO] Cálculo de estado para albarán ${albaranId}:`, {
          tieneJefeEquipo: !!tieneJefeEquipo,
          materialesCount: materiales.length,
          estadosMateriales: estadosMateriales,
          estadoActual: estadoActual,
          materialesDetalle: materiales.map(m => {
            const mData = m.attributes || m;
            return {
              id: mData.id,
              estado: mData.estado,
              tipo: mData.tipo_material,
              tieneActivo: !!mData.activo,
              cantidad: mData.cantidad
            };
          })
        });
      }

      if (estadosMateriales.length === 0) {
        return estadoActual || 'asignado';
      }

      // PRIORIDAD 0 (MÁS ALTA): Verificar si hay algún material con problemas (rechazado, no_devuelto, incidencia)
      const tieneProblemas = estadosMateriales.some(estado => 
        estado === 'rechazado' || estado === 'no_devuelto' || estado === 'incidencia'
      );
      if (tieneProblemas) {
        return 'incidencia';
      }

      // Filtrar estados problemáticos para el resto del cálculo (excluir rechazados, no_devueltos, incidencias)
      const estadosMaterialesFiltrados = estadosMateriales.filter(estado => 
        estado !== 'rechazado' && estado !== 'no_devuelto' && estado !== 'incidencia'
      );

      if (estadosMaterialesFiltrados.length === 0) {
        return estadoActual || 'asignado';
      }

      // Verificar si hay algún material en estado pendiente_aceptar_devolucion
      const tienePendienteDevolucion = estadosMaterialesFiltrados.some(estado => estado === 'pendiente_aceptar_devolucion');
      if (tienePendienteDevolucion) {
        return 'pendiente_aceptar_devolucion';
      }

      // Verificar si todos los materiales están devueltos
      const todosDevueltos = estadosMaterialesFiltrados.every(estado => estado === 'devuelto');
      if (todosDevueltos) {
        return 'devuelto';
      }

      // Verificar si hay algún material en estado pendiente_aceptar
      const tienePendienteAceptar = estadosMaterialesFiltrados.some(estado => estado === 'pendiente_aceptar');
      if (tienePendienteAceptar) {
        return 'asignado';
      }

      // Si hay al menos un material entregado (aunque no todos) → entregado
      // Esto cubre el caso de materiales entregados + materiales devueltos
      const tieneEntregados = estadosMaterialesFiltrados.some(estado => estado === 'entregado');
      if (tieneEntregados) {
        return 'entregado';
      }

      // Por defecto, si tiene jefe asignado → asignado
      return 'asignado';
    },

    mapEstadoToApi(estado) {
      const mapping = {
        "Sin Asignar": "pendiente_asignar",
        "Asignado": "asignado",
        "Entregado": "entregado",
        "Devuelto": "devuelto",
        "Revisar Devolución": "pendiente_aceptar_devolucion",
        "Cerrado": "cerrado",
        "Cerrado sin tarea": "cerrado_sin_tarea"
      };
      return mapping[estado];
    },

    handleSelectionChange(val) {
      this.selectedRows = val;
    },

    addAlbaran() {
      this.$router.push({ name: "Add Albaran" });
    },

    goToStats() {
      this.$router.push({ name: "Albaran Stats" });
    },

    editAlbaran(albaran) {
      this.$router.push({
        name: "Edit Albaran",
        params: { id: albaran.id }
      });
    },

    viewAlbaran(albaran) {
      this.$router.push({
        name: "View Albaran",
        params: { id: albaran.id }
      });
    },

    handleRowClick(row, column, event) {
      // Obtener el albarán desde la fila (puede estar en row o row.attributes)
      const albaran = row.attributes || row;
      this.viewAlbaran(albaran);
    },

    puedeEliminarAlbaran(row) {
      const numero = row.attributes?.numero || row.numero;
      const materiales = row.attributes?.albaran_activo_materials || row.albaran_activo_materials || [];
      const esClon = row.attributes?.es_clon || row.es_clon;
      
      // Verificar si es un albarán manual (empieza por ST-)
      const esManual = numero && typeof numero === 'string' && numero.startsWith('ST-');
      
      if (esManual) {
        // Para albaranes manuales (ST-), solo se pueden eliminar si no tienen materiales asignados
        if (materiales && materiales.length > 0) {
          return {
            puede: false,
            motivo: "No se puede eliminar un albarán manual que tiene materiales asignados"
          };
        }
        return { puede: true };
      }
      
      // Para albaranes clonados, verificar restricciones
      if (esClon) {
      const estado = row.attributes?.estado || row.estado;
      const tieneUsuario = row.attributes?.users_permissions_user || row.users_permissions_user;
      
      // No se puede eliminar si tiene materiales asignados
      if (materiales && materiales.length > 0) {
        return {
          puede: false,
          motivo: "No se puede eliminar un albarán clonado que tiene materiales asignados"
        };
      }
      
      // No se puede eliminar si está asignado a un jefe de equipo
      if (tieneUsuario) {
        return {
          puede: false,
          motivo: "No se puede eliminar un albarán clonado que está asignado a un jefe de equipo"
        };
      }
      
      // No se puede eliminar si no está en estado pendiente_asignar
      if (estado && estado !== 'pendiente_asignar') {
        return {
          puede: false,
          motivo: `No se puede eliminar un albarán clonado en estado "${this.formatEstado(estado)}". Solo se pueden eliminar albaranes clonados en estado "Pendiente asignar" sin materiales asignados.`
        };
      }
      
      // Se puede eliminar si es clon, está en pendiente_asignar, sin materiales y sin usuario
      return { puede: true };
      }
      
      // Para otros tipos de albaranes, no se pueden eliminar
      return {
        puede: false,
        motivo: "Solo se pueden eliminar albaranes manuales (ST-) sin materiales o albaranes clonados en estado 'Pendiente asignar' sin materiales asignados"
      };
    },
    
    async deleteAlbaran(id, row = null) {
      try {
        // Si no se proporciona el row, buscarlo en la lista
        if (!row) {
          row = this.albaranes.find(a => (a.attributes?.id || a.id) === id);
        }
        
        // Verificar si se puede eliminar (especialmente para clonados)
        if (row) {
          const validacion = this.puedeEliminarAlbaran(row);
          if (!validacion.puede) {
            this.$notify({
              type: "warning",
              message: validacion.motivo || "No se puede eliminar este albarán"
            });
            return;
          }
        }
        
        const numero = row?.attributes?.numero || row?.numero;
        const esManual = numero && typeof numero === 'string' && numero.startsWith('ST-');
        const esClon = row && (row.attributes?.es_clon || row.es_clon);
        
        const tituloConfirmacion = esManual
          ? "¿Estás seguro de eliminar este albarán manual?"
          : esClon 
          ? "¿Estás seguro de eliminar este albarán clonado?"
          : "¿Estás seguro?";
        const textoConfirmacion = esManual
          ? "Esta acción eliminará el albarán manual. Esta acción no se puede deshacer."
          : esClon
          ? "Esta acción eliminará el albarán clonado. Esta acción no se puede deshacer."
          : "Esta acción no se puede deshacer";
        
        const result = await swal.fire({
          title: tituloConfirmacion,
          text: textoConfirmacion,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí, eliminar",
          cancelButtonText: "Cancelar",
          confirmButtonClass: "btn btn-danger",
          cancelButtonClass: "btn btn-secondary",
        });

        if (result.value) {
          await this.$store.dispatch("albaranes/destroy", id);
          this.$notify({
            type: "success",
            message: "Albarán eliminado correctamente"
          });
          this.getList();
        }
      } catch (error) {
        console.error("Error deleting albaran:", error);
        this.$notify({
          type: "danger",
          message: `Error al eliminar el albarán: ${error.response?.data?.error?.message || error.message || "Error desconocido"}`
        });
      }
    },

    sortChange({ prop, order }) {
      const direction = order === "descending" ? "desc" : "asc";
      this.sort = [`${prop}:${direction}`];
      this.getList();
    },

    handleSelectedDateChange() {
      if (this.selectedDate) {
        // Ya no necesitamos establecer fdesde y fhasta ya que filtramos directamente por fecha_entrega
        this.fdesde = "";
        this.fhasta = "";
      } else {
        this.fdesde = "";
        this.fhasta = "";
      }
      this.getListDebounced();
    },

    clearSearchState() {
      // Limpiar también el texto del buscador
      this.queryInput = "";
      this.query = "";
      this.estado = "Todos";
      this.tareaAsociada = "Todos";
      this.proyectoFiltro = "Todos";
      // Reset paginación
      if (this.pagination?.currentPage) this.pagination.currentPage = 1;

      this.saveListState();
      // No limpiar la navegación por días, solo los subfiltros
      // Recargar la lista después de limpiar los filtros
      this.getList();
    },

    getUserName(row) {
      const userData = row.attributes.users_permissions_user;
      if (userData?.nombre && userData?.apellidos) {
        return `${userData.nombre} ${userData.apellidos}`;
      }
      return 'Sin asignar';
    },

    async loadExternalAlbaranes() {
        this.loadingExternal = true;
      try {
        console.log('🔄 [SYNC] Iniciando sincronización con Keikaku...');
        
        // Crear una nueva instancia de axios para esta petición específica
        const axiosInstance = axios.create({
          headers: {
            'Accept': undefined,
            'Content-Type': undefined
          }
        });
        
        const syncDesde = moment().subtract(7, 'days').startOf('day');
        const syncHasta = moment().add(30, 'days').endOf('day');

        const getTareaFechaMoment = (tarea) => {
          const raw = tarea.FechaInicio || tarea.Properties?.FechaInicio?.Value;
          if (!raw) return null;
          const fecha = moment(raw);
          return fecha.isValid() ? fecha : null;
        };

        const isTareaEnVentana = (tarea) => {
          const fecha = getTareaFechaMoment(tarea);
          if (!fecha) return false;
          return !fecha.isBefore(syncDesde) && !fecha.isAfter(syncHasta);
        };

        // Keikaku no soporta filter por FechaInicio (500). Paginar sin filtro y acotar en cliente.
        const fetchTareasKeikakuVentana = async () => {
          const pageSize = 500;
          const maxPages = 30;
          const acumulado = [];
          const idsVistos = new Set();

          for (let page = 0; page < maxPages; page += 1) {
            const tareasQueryParams = new URLSearchParams({
              page: String(page),
              pageSize: String(pageSize),
              orderBy: 'FechaInicio desc',
              access_token: KEIKAKU_ACCESS_TOKEN,
            }).toString().replace(/\+/g, '%20');

            let batch = [];
            try {
              const tareasResponse = await axiosInstance.request({
                method: 'get',
                maxBodyLength: Infinity,
                url: `${KEIKAKU_API_BASE_URL}/list/Planificador_Equipo_Movil?${tareasQueryParams}`,
                headers: {},
              });
              batch = Array.isArray(tareasResponse.data)
                ? tareasResponse.data
                : (tareasResponse.data?.data || []);
            } catch (error) {
              console.warn(`⚠️ [SYNC] Error página ${page} Keikaku:`, error.message);
              break;
            }

            if (!batch.length) break;

            let fechaMinPagina = null;

            batch.forEach((tarea) => {
              const fecha = getTareaFechaMoment(tarea);
              if (fecha && (!fechaMinPagina || fecha.isBefore(fechaMinPagina))) {
                fechaMinPagina = fecha;
              }

              const idTarea = tarea.IdTarea || tarea.Properties?.IdTarea?.Value;
              if (!idTarea || idsVistos.has(String(idTarea))) return;
              if (!isTareaEnVentana(tarea)) return;

              idsVistos.add(String(idTarea));
              acumulado.push(tarea);
            });

            // Con orderBy desc las fechas bajan al paginar: cortar cuando ya pasamos la ventana
            if (fechaMinPagina && fechaMinPagina.isBefore(syncDesde)) {
              break;
            }

            if (batch.length < pageSize) break;
          }

          return acumulado;
        };

        console.log(
          '📊 [SYNC] Consultando tareas Keikaku (paginado, ventana',
          syncDesde.format('YYYY-MM-DD'),
          '→',
          syncHasta.format('YYYY-MM-DD'),
          ')'
        );
        const tareas = await fetchTareasKeikakuVentana();
        
        console.log('📊 [SYNC] Respuesta de tareas:', {
          ventana: `${syncDesde.format('YYYY-MM-DD')} → ${syncHasta.format('YYYY-MM-DD')}`,
          totalTareas: tareas.length,
          primeras3Tareas: tareas.slice(0, 3).map(t => ({
            IdTarea: t.IdTarea || t.Properties?.IdTarea?.Value,
            FechaInicio: t.FechaInicio || t.Properties?.FechaInicio?.Value
          }))
        });

        if (tareas.length === 0) {
          this.$notify({
            type: "warning",
            message: "No hay tareas disponibles en Keikaku"
          });
          return;
        }

        // Segunda llamada: obtener todos los materiales
        const materialQueryParams = new URLSearchParams({
          page: '0',
          orderBy: 'IdTarea desc',
          pageSize: '1000', // Aumentar para obtener todos los materiales
          access_token: KEIKAKU_ACCESS_TOKEN
        }).toString().replace(/\+/g, '%20');

        let materialConfig = {
          method: 'get',
          maxBodyLength: Infinity,
          url: `https://aplicaciones.salvadorvertical.com/Keikaku/webapi/list/Tarea_Material?${materialQueryParams}`,
          headers: { }
        };

        console.log('📊 [SYNC] Consultando materiales...');
        const materialResponse = await axiosInstance.request(materialConfig);
        
        // Crear un mapa de materiales por IdTarea
        const materialesPorTarea = {};
        materialResponse.data.forEach(item => {
          if (!materialesPorTarea[item.IdTarea]) {
            materialesPorTarea[item.IdTarea] = [];
          }
          materialesPorTarea[item.IdTarea].push(item);
        });

        // Solo tareas con material en Keikaku (nunca sincronizar sin material)
        const tareasConMateriales = {};
        tareas.forEach(tarea => {
          const idTarea = tarea.IdTarea || tarea.Properties?.IdTarea?.Value;
          if (idTarea && materialesPorTarea[idTarea] && materialesPorTarea[idTarea].length > 0) {
            tareasConMateriales[idTarea] = materialesPorTarea[idTarea];
          }
        });

        console.log('📊 [SYNC] Tareas con material en ventana:', {
          totalTareasUnicas: Object.keys(tareasConMateriales).length,
        });

        // OPTIMIZACIÓN 1: Verificar duplicados en batch (una sola llamada para todas las tareas)
        const tareaIds = Object.keys(tareasConMateriales);
        console.log('🔍 [SYNC] Verificando duplicados en batch para', tareaIds.length, 'tareas...');
        
        const existingAlbaranesMap = new Map();
        try {
          // Hacer una llamada para obtener todos los albaranes existentes de una vez
          const duplicateCheckPromises = tareaIds.map(idTarea => 
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/albaran-activos`, {
              params: {
                'filters[tarea_keikaku_id]': idTarea,
                'pagination[pageSize]': 1
              },
              headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
              }
            }).then(response => {
              if (response.data.data && response.data.data.length > 0) {
                existingAlbaranesMap.set(idTarea, response.data.data[0]);
              }
              return { idTarea, success: true };
            }).catch(error => {
              console.log(`⚠️ [SYNC] Error verificando duplicado para tarea ${idTarea}:`, error.message);
              return { idTarea, success: false };
            })
          );
          
          // Ejecutar todas las verificaciones en paralelo
          await Promise.allSettled(duplicateCheckPromises);
          console.log('✅ [SYNC] Verificación de duplicados completada. Encontrados:', existingAlbaranesMap.size);
        } catch (error) {
          console.error('❌ [SYNC] Error en verificación batch de duplicados:', error);
        }

        const createdAlbaranes = [];
        const skippedTasks = [];
        
        // OPTIMIZACIÓN 2: Función helper para procesar una tarea
        const processTask = async (idTarea, materiales) => {
          try {
            console.log(`🔄 [SYNC] Procesando tarea:`, {
              IdTarea: idTarea,
              cantidadMateriales: materiales.length
            });

            // OPTIMIZACIÓN 3: Obtener detalles de tarea primero (necesario para el resto)
            const tareaConfig = {
                  method: 'get',
                  maxBodyLength: Infinity,
              url: `https://aplicaciones.salvadorvertical.com/Keikaku/webapi/object/Planificador_Equipo_Movil/${idTarea}?access_token=${KEIKAKU_ACCESS_TOKEN}`,
                  headers: { }
                };
                
            const tareaResponse = await axiosInstance.request(tareaConfig);
            const tareaData = tareaResponse.data.Properties;

            // Verificar si la tarea es de hace una semana en adelante
            const today = moment().startOf('day');
            const oneWeekAgo = moment().subtract(7, 'days').startOf('day');
            const taskDate = moment(tareaData.FechaInicio?.Value).startOf('day');
            
            if (taskDate.isBefore(oneWeekAgo)) {
              console.log('⚠️ [SYNC] Tarea anterior a hace una semana, saltando:', idTarea);
              return {
                skipped: true,
                id: idTarea,
                motivo: 'Fecha anterior a hace una semana',
                fecha: tareaData.FechaInicio?.Value
              };
            }

            // OPTIMIZACIÓN 4: Hacer llamadas en paralelo para parte, cliente y jefe de equipo
            const idParte = tareaData.IdParte?.Value;
            const idCliente = tareaData.IdCliente?.Value;
            
            const [parteResult, clienteResult, jefeEquipoResult] = await Promise.allSettled([
              // Parte de trabajo
              idParte ? axiosInstance.request({
                method: 'get',
                maxBodyLength: Infinity,
                url: `https://aplicaciones.salvadorvertical.com/SAT/webapi/list/sat_Parte?${new URLSearchParams({
                  filter: `Partes.IdParte=${idParte}`,
                  page: '0',
                  pageSize: '5000',
                  orderBy: 'IdParte desc',
                  access_token: SAT_ACCESS_TOKEN
                }).toString().replace(/\+/g, '%20')}`,
                  headers: {}
              }).then(response => {
                if (response.data && response.data.length > 0) {
                  return response.data[0];
                }
                return null;
              }).catch(() => null) : Promise.resolve(null),
              
              // Cliente
              idCliente ? axiosInstance.request({
                  method: 'get',
                  maxBodyLength: Infinity,
                url: `https://aplicaciones.salvadorvertical.com/Keikaku/webapi/object/Cliente/${idCliente}?access_token=${KEIKAKU_ACCESS_TOKEN}`,
                  headers: { }
              }).then(response => {
                const clienteData = response.data.Properties;
                return clienteData.Cliente?.Value || clienteData.RazonSocial?.Value || 'Sin especificar';
              }).catch(() => 'Error al obtener cliente') : Promise.resolve('Sin especificar'),
              
              // Jefe de equipo
              axiosInstance.request({
                method: 'get',
                maxBodyLength: Infinity,
                url: `https://aplicaciones.salvadorvertical.com/Keikaku/webapi/list/Empleado_Tarea?filter=FLX_Pers_Tareas_Empleados.IdTarea='${idTarea}'&access_token=${KEIKAKU_ACCESS_TOKEN}`,
                headers: {}
              }).then(response => {
                const empleadosTarea = response.data || [];
                const jefeEquipo = empleadosTarea.find(emp => emp.Responsable === true);
                return jefeEquipo?.IdEmpleado_flxtext || null;
              }).catch(() => null)
            ]);

            const parteTrabajo = parteResult.status === 'fulfilled' ? parteResult.value : null;
            const clienteNombre = clienteResult.status === 'fulfilled' ? clienteResult.value : 'Sin especificar';
            const jefeEquipoNombre = jefeEquipoResult.status === 'fulfilled' ? jefeEquipoResult.value : null;
            
            // Actualizar tareaData con la información del jefe de equipo
            if (jefeEquipoNombre) {
              if (!tareaData.PersonasAsignadas) {
                tareaData.PersonasAsignadas = {};
              }
              tareaData.PersonasAsignadas.Text = jefeEquipoNombre;
              tareaData.PersonasAsignadas.TextVa = jefeEquipoNombre;
              }
              
            // Verificar si ya existe un albarán (usando el mapa pre-cargado)
            const albaranExistente = existingAlbaranesMap.get(idTarea);
            
            if (albaranExistente) {
              // Obtener materiales actuales del albarán existente
              const materialesActuales = albaranExistente.attributes?.materiales_taller || albaranExistente.materiales_taller || [];
              
              // Obtener IDs de materiales actuales para comparar
              const idsMaterialesActuales = materialesActuales.map(m => m.idArticulo_flxtext);
              
              // Filtrar materiales nuevos de Keikaku
              const materialesNuevos = materiales.filter(material => 
                !idsMaterialesActuales.includes(material.IdArticulo_flxtext)
              );
              
              // Verificar si necesita actualizar parte_trabajo
              const tieneParteTrabajo = albaranExistente.attributes?.parte_trabajo || albaranExistente.parte_trabajo;
              const necesitaActualizarParte = idParte && !tieneParteTrabajo;
              
              // Preparar datos de actualización
              const updateData = {};
              let necesitaActualizar = false;
              
              if (materialesNuevos.length > 0) {
                // Actualizar el albarán con los nuevos materiales
                const materialesActualizados = [
                  ...materialesActuales,
                  ...materialesNuevos.map(material => ({
                    idArticulo: material.IdArticulo,
                    idArticulo_flxtext: material.IdArticulo_flxtext,
                    cantidad: material.Cantidad,
                    descripcion: material.Descripcion || '',
                    unidad: material.Unidad || ''
                  }))
                ];

                updateData.materiales_taller = materialesActualizados;
                necesitaActualizar = true;
              }
              
              // Agregar parte_trabajo si no existe y tenemos los datos
              if (necesitaActualizarParte && parteTrabajo) {
                updateData.parte_trabajo = parteTrabajo;
                
                // Verificar si es facturable (p_TareaFacturacion = 4 o 5)
                const esFacturable = parteTrabajo.p_TareaFacturacion === 4 || parteTrabajo.p_TareaFacturacion === 5;
                if (esFacturable) {
                  updateData.es_facturable = true;
                }
                
                necesitaActualizar = true;
              }
              
              if (necesitaActualizar) {
                try {
                  // Actualizar el albarán con los materiales combinados y/o parte_trabajo
                  await axios.put(
                    `${process.env.VUE_APP_API_BASE_URL}/albaran-activos/${albaranExistente.id}`,
                    {
                      data: updateData
                    },
                    {
                      headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                      }
                    }
                  );

                  const materialesAñadidos = materialesNuevos.length || 0;

                  // Añadir a la lista de albaranes actualizados
                  return {
                    success: true,
                    id: albaranExistente.id,
                    numero: albaranExistente.attributes?.numero || albaranExistente.numero,
                    action: 'updated',
                    materialesAñadidos: materialesAñadidos,
                    parteTrabajoActualizada: !!updateData.parte_trabajo
                  };

                } catch (error) {
                  console.error('❌ [SYNC] Error actualizando materiales del albarán:', error);
                  return {
                    skipped: true,
                    id: idTarea,
                    motivo: 'Error actualizando materiales',
                    numero: albaranExistente.attributes?.numero || albaranExistente.numero,
                    error: error.message
                  };
                }
              } else {
                // Si no hay materiales nuevos pero sí hay parte_trabajo que actualizar
                if (necesitaActualizarParte && parteTrabajo) {
                  try {
                    // Verificar si es facturable (p_TareaFacturacion = 4 o 5)
                    const esFacturable = parteTrabajo.p_TareaFacturacion === 4 || parteTrabajo.p_TareaFacturacion === 5;
                    const updateDataParte = {
                      parte_trabajo: parteTrabajo
                    };
                    
                    if (esFacturable) {
                      updateDataParte.es_facturable = true;
                    }
                    
                    await axios.put(
                      `${process.env.VUE_APP_API_BASE_URL}/albaran-activos/${albaranExistente.id}`,
                      {
                        data: updateDataParte
                      },
                      {
                        headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `Bearer ${localStorage.getItem('token')}`
                        }
                      }
                    );
                    
                    return {
                      success: true,
                      id: albaranExistente.id,
                      numero: albaranExistente.attributes?.numero || albaranExistente.numero,
                      action: 'updated',
                      materialesAñadidos: 0,
                      parteTrabajoActualizada: true
                    };
                  } catch (error) {
                    console.error('❌ [SYNC] Error actualizando parte_trabajo:', error);
                    return {
                      skipped: true,
                      id: idTarea,
                      motivo: 'Error actualizando parte_trabajo',
                      error: error.message
                    };
                  }
                } else {
                  return {
                    skipped: true,
                  id: idTarea,
                    motivo: 'Sin materiales nuevos ni parte_trabajo',
                  numero: albaranExistente.attributes?.numero || albaranExistente.numero
                  };
                }
              }
            }
            
            // Crear nuevo albarán
            // Obtener información del usuario responsable desde Keikaku
            let observacionesPreasignacion = '';
            if (tareaData.IdResponsable?.Text) {
              observacionesPreasignacion = `Preasignado a ${tareaData.IdResponsable.Text}`;
            } else {
              observacionesPreasignacion = 'Preasignado automáticamente';
            }

            // Verificar si es facturable (p_TareaFacturacion = 4 o 5)
            const esFacturable = parteTrabajo && (parteTrabajo.p_TareaFacturacion === 4 || parteTrabajo.p_TareaFacturacion === 5);

            // Crear datos del albarán
            const albaranData = {
              numero: `T${idTarea}`,
              qr: `ALB${moment().format('YYMMDDHHmmss')}${idTarea}${Math.random().toString(36).substr(2, 5)}`,
              estado: "pendiente_asignar",
              fecha_entrega: tareaData.FechaInicio?.Value,
              fecha_devolucion: tareaData.FechaFin?.Value,
              observaciones: `${observacionesPreasignacion}${tareaData.Observaciones?.Value ? ' - ' + tareaData.Observaciones.Value : ''}`,
              titulo: tareaData.Titulo?.Value || `Tarea ${idTarea}`,
              descripcion: tareaData.Descrip?.Value || '',
              cliente: clienteNombre,
              tarea_keikaku_id: idTarea,
              tarea_keikaku_data: tareaData,
              parte_trabajo: parteTrabajo,
              es_facturable: esFacturable,
              materiales_taller: materiales.map(material => ({
                idArticulo: material.IdArticulo,
                idArticulo_flxtext: material.IdArticulo_flxtext,
                cantidad: material.Cantidad,
                descripcion: material.Descripcion || '',
                unidad: material.Unidad || ''
              }))
            };

            // Crear el albarán
            const createdAlbaran = await this.$store.dispatch("albaranes/add", { ...albaranData, skipFilters: true });
            
            return {
              success: true,
              id: createdAlbaran.id,
              numero: createdAlbaran.numero,
              action: 'created'
            };

      } catch (error) {
            console.error('❌ [SYNC] Error procesando tarea:', {
              error: error.message,
              taskId: idTarea
            });
            return {
              skipped: true,
              id: idTarea,
              motivo: 'Error en procesamiento',
              error: error.message
            };
          }
        };

        // OPTIMIZACIÓN 5: Procesar tareas en paralelo con control de concurrencia
        const CONCURRENT_TASKS = 5; // Procesar 5 tareas a la vez
        const taskEntries = Object.entries(tareasConMateriales);
        
        console.log(`🚀 [SYNC] Procesando ${taskEntries.length} tareas en lotes de ${CONCURRENT_TASKS}...`);
        
        for (let i = 0; i < taskEntries.length; i += CONCURRENT_TASKS) {
          const batch = taskEntries.slice(i, i + CONCURRENT_TASKS);
          console.log(`📦 [SYNC] Procesando lote ${Math.floor(i / CONCURRENT_TASKS) + 1}/${Math.ceil(taskEntries.length / CONCURRENT_TASKS)} (${batch.length} tareas)`);
          
          const results = await Promise.allSettled(
            batch.map(([idTarea, materiales]) => processTask(idTarea, materiales))
          );
          
          // Procesar resultados
          results.forEach((result, index) => {
            if (result.status === 'fulfilled') {
              const taskResult = result.value;
              if (taskResult.skipped) {
                skippedTasks.push(taskResult);
              } else if (taskResult.success) {
                createdAlbaranes.push(taskResult);
              }
            } else {
              const [idTarea] = batch[index];
              skippedTasks.push({
                id: idTarea,
                motivo: 'Error en procesamiento',
                error: result.reason?.message || 'Error desconocido'
              });
            }
          });
        }

        // Mostrar resumen de la sincronización
        const albaranesCreados = createdAlbaranes.filter(a => a.action !== 'updated').length;
        const albaranesActualizados = createdAlbaranes.filter(a => a.action === 'updated').length;
        const totalMaterialesAñadidos = createdAlbaranes
          .filter(a => a.action === 'updated')
          .reduce((sum, a) => sum + (a.materialesAñadidos || 0), 0);

        console.log('📊 [SYNC] Resumen de sincronización:', {
          totalTareas: Object.keys(tareasConMateriales).length,
          albaranesCreados: albaranesCreados,
          albaranesActualizados: albaranesActualizados,
          totalMaterialesAñadidos: totalMaterialesAñadidos,
          tareasSaltadas: skippedTasks.length
        });

        if (createdAlbaranes.length > 0) {
          let message = `✅ Sincronización completada: `;
          if (albaranesCreados > 0) {
            message += `${albaranesCreados} albaranes creados`;
          }
          if (albaranesActualizados > 0) {
            if (albaranesCreados > 0) message += `, `;
            message += `${albaranesActualizados} albaranes actualizados con ${totalMaterialesAñadidos} materiales nuevos`;
          }
          message += ` de ${Object.keys(tareasConMateriales).length} tareas procesadas`;

          this.$notify({
            type: "success",
            message: message
          });
          
          // Recargar el mes completo según la vista actual para mostrar los nuevos albaranes
          if (this.currentView === 'calendar') {
            await this.loadCalendarMonth();
          } else if (this.currentView === 'list') {
            await this.loadListMonth();
          } else {
          await this.getList();
          }
        } else if (skippedTasks.length > 0) {
          this.$notify({
            type: "warning",
            message: `⚠️ No se crearon nuevos albaranes. ${skippedTasks.length} tareas ya tienen albarán asociado o están en el pasado`
          });
        } else {
          this.$notify({
            type: "warning",
            message: "⚠️ No hay tareas nuevas disponibles en Keikaku"
          });
        }

      } catch (error) {
        console.error('❌ [SYNC] Error en sincronización con Keikaku:', error);
        this.$notify({
          type: "danger",
          message: "❌ Error al sincronizar con Keikaku: " + (error.message || "Error desconocido")
        });
      } finally {
        this.loadingExternal = false;
      }
    },
    getMaterialesCount(row) {
      return row.attributes.albaranActivoMaterials ? row.attributes.albaranActivoMaterials.length : 0;
    },
    getMaterialesTooltip(row) {
      const count = this.getMaterialesCount(row);
      if (count === 0) {
        return "No hay materiales asignados";
      }
      return `${count} materiales asignados`;
    },
    getMaterialesTallerCount(row) {
      // Manejar ambas estructuras: endpoint estándar (attributes) y endpoint específico (directo)
      const materialesTaller = row.attributes?.materiales_taller || row.materiales_taller;
      
      // Si es un clon, contar directamente desde albaran_activo_materials
      const esClon = row.attributes?.es_clon || row.es_clon || row.attributes?.albaran_original_id || row.albaran_original_id;
      if (esClon) {
        // Obtener los materiales clonados (de albaran_activo_materials)
        let materialesClonados = [];
        if (row.attributes?.albaran_activo_materials) {
          materialesClonados = row.attributes.albaran_activo_materials;
        } else if (row.albaran_activo_materials) {
          materialesClonados = row.albaran_activo_materials;
        }
        
        // Contar directamente desde los materiales clonados
        let totalCantidad = 0;
        materialesClonados.forEach(material => {
          const materialData = material.attributes || material;
          
          // Si es un consumible, tiene cantidad
          if (materialData.cantidad) {
            totalCantidad += parseInt(materialData.cantidad) || 0;
          } else if (materialData.activo || materialData.tipo_material === 'activo' || materialData.es_saca) {
            // Si es un activo o Saca, cuenta como 1
            totalCantidad += 1;
          }
        });
        
        return totalCantidad;
      }
      
      // Si no es clon, contar todos los materiales de materiales_taller
      if (!materialesTaller || !Array.isArray(materialesTaller)) {
        return 0;
      }
      
      const totalCantidad = materialesTaller.reduce((sum, material) => {
        const cantidad = parseInt(material.cantidad) || 0;
        return sum + cantidad;
      }, 0);
      
      return totalCantidad;
    },
    getMaterialesTallerTooltip(row) {
      // Manejar ambas estructuras: endpoint estándar (attributes) y endpoint específico (directo)
      const materialesTaller = row.attributes?.materiales_taller || row.materiales_taller;
      if (!materialesTaller || !Array.isArray(materialesTaller) || materialesTaller.length === 0) {
        return "No hay materiales del taller asignados";
      }
      
      // Calcular total de cantidades
      const totalCantidad = materialesTaller.reduce((sum, material) => {
        const cantidad = parseInt(material.cantidad) || 0;
        return sum + cantidad;
      }, 0);
      
      const materialesList = materialesTaller.map(m => 
        `${m.idArticulo_flxtext} (${m.cantidad} ${m.unidad || 'un'})`
      ).join('\n');
      
      return `Total: ${totalCantidad} unidades de ${materialesTaller.length} materiales:\n${materialesList}`;
    },


  }
};
</script>

<style>
/* CSS corporativo para botones */
.btn-corporate {
  background-color: white !important;
  border-color: #7f1058 !important;
  color: #7f1058 !important;
  font-weight: 500 !important;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.btn-corporate:hover {
  background-color: #7f1058 !important;
  border-color: #7f1058 !important;
  color: white !important;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(127, 16, 88, 0.3);
}

.btn-corporate.active {
  background-color: #7f1058 !important;
  border-color: #7f1058 !important;
  color: white !important;
  box-shadow: 0 2px 4px rgba(127, 16, 88, 0.3);
}

/* CSS para KPIs - Números más grandes */
.kpi-number {
  font-size: 2.5rem !important;
  font-weight: 700 !important;
  line-height: 1.2 !important;
}

.kpi-number i {
  font-size: 1.5rem !important;
  margin-right: 0.5rem !important;
}

/* Contenedor de KPIs estándar del proyecto */
.kpi-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.kpi-item {
  flex: 1 1 calc(25% - 20px);
  max-width: calc(25% - 20px);
}

.badge-danger {
  background-color: #f5365c;
}
.badge-warning {
  background-color: #fb6340;
}
.badge-success {
  background-color: #2dce89;
}
.badge-info {
  background-color: #11cdef;
}
.badge-dark {
  background-color: #172b4d;
}
.clear-filters-btn {
  background: none;
  border: none;
  color: #fb6340;
  padding: 0;
  font-size: 1.2rem;
}
.clear-filters-btn:hover {
  color: #f5365c;
}
.has-filter input {
  border-color: #2dce89;
}
.mr-2 {
  margin-right: 0.5rem;
}

/* Estilos para la columna de usuario asignado */
.avatar.avatar-xs {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
}

.text-muted {
  color: #8898aa !important;
  font-size: 0.875rem;
}

.d-flex.align-items-center {
  min-height: 40px;
}

.albaran-search-row {
  /* Asegura misma altura entre input y botón */
  min-height: 46px;
}

.albaran-search-input :deep(input),
.albaran-search-input :deep(.form-control) {
  height: 46px !important;
}

.albaran-search-btn {
  height: 46px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  white-space: nowrap;
}

.d-block {
  display: block !important;
  font-size: 0.75rem;
  line-height: 1.2;
  margin-top: 2px;
}

/* Asegurar que la columna de ACCIONES mantenga la misma altura y alineación */
.el-table th:last-child {
  height: 40px !important;
  line-height: 23px !important;
  vertical-align: middle !important;
  padding: 8px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* Asegurar que todas las columnas de ACCIONES en cualquier tabla tengan alineación correcta */
.el-table th[data-column="actions"],
.el-table th:last-child {
  height: 40px !important;
  line-height: 23px !important;
  vertical-align: middle !important;
  padding: 8px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;
}

/* Estilos para filtros reorganizados */
.filter-group {
  margin-bottom: 1rem;
}

.filter-label {
  display: block;
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
}

.filter-label i {
  color: #6c757d;
}

.day-navigation-compact .btn-group .btn {
  border-radius: 6px;
  margin: 0 2px;
}

.day-navigation-compact .btn-primary {
  background-color: #007bff;
  border-color: #007bff;
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.3);
}

.day-navigation-compact .btn-outline-primary {
  color: #007bff;
  border-color: #007bff;
}

.day-navigation-compact .btn-outline-primary:hover {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
}

.month-navigation-compact .btn-group .btn {
  border-radius: 6px;
  margin: 0 2px;
}

.month-navigation-compact .btn-primary {
  background-color: #007bff;
  border-color: #007bff;
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.3);
}

.month-navigation-compact .btn-outline-primary {
  color: #007bff;
  border-color: #007bff;
}

.month-navigation-compact .btn-outline-primary:hover {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
}

/* Estilos para botones de vista con altura consistente */
.filter-group .btn-group .btn {
  height: 46px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  margin: 0 2px;
}

.filter-group .btn-group .btn.active {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.3);
}

.filter-group .btn-group .btn:not(.active) {
  color: #007bff;
  border-color: #007bff;
  background-color: transparent;
}

.filter-group .btn-group .btn:not(.active):hover {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
}

.day-title {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1rem;
  border: 1px solid #dee2e6;
}

.day-title h5 {
  color: #495057;
  font-weight: 600;
}

.day-title h5 i {
  color: #007bff;
}

/* Estilos para navegación por días (mantener para compatibilidad) */
.day-navigation {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1rem;
  border: 1px solid #dee2e6;
}

.day-navigation h5 {
  color: #495057;
  font-weight: 600;
}

.day-navigation .btn-group .btn {
  border-radius: 6px;
  margin: 0 2px;
}

.day-navigation .btn-primary {
  background-color: #007bff;
  border-color: #007bff;
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.3);
}

.day-navigation .btn-outline-primary {
  color: #007bff;
  border-color: #007bff;
}

.day-navigation .btn-outline-primary:hover {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
}

/* Estilos para el calendario */
.calendar-container {
  padding: 1rem;
  overflow-x: auto;
  width: 100%;
  max-width: 100%;
}

.calendar-grid {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  overflow: hidden;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
}

.calendar-month-header {
  background: #f8f9fa;
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
}

.calendar-month-header h4 {
  font-size: 1.5rem;
  font-weight: 600;
}

.calendar-weekdays {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  background: #e9ecef;
  border-bottom: 1px solid #dee2e6;
  width: 100%;
  max-width: 100%;
}

.calendar-weekday {
  padding: 0.75rem;
  text-align: center;
  font-weight: 600;
  font-size: 1.1rem;
  color: #495057;
  border-right: 1px solid #dee2e6;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  box-sizing: border-box;
}

.calendar-weekday:last-child {
  border-right: none;
}

.calendar-days {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  grid-template-rows: repeat(auto-fit, 1fr);
  min-height: 400px;
  width: 100%;
  max-width: 100%;
}

.calendar-day {
  border-right: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
  padding: 0.4rem;
  min-height: 120px;
  position: relative;
  background: white;
  transition: background-color 0.2s;
  min-width: 0;
  overflow: hidden;
  max-width: 100%;
  box-sizing: border-box;
}

.calendar-day:hover {
  background-color: #f8f9fa;
}

.calendar-day.other-month {
  background-color: #f8f9fa;
  color: #6c757d;
}

.calendar-day.empty-day {
  background-color: #f8f9fa;
  cursor: default;
}

.calendar-day.empty-day:hover {
  background-color: #f8f9fa;
}

.calendar-day.today {
  background-color: #e3f2fd;
  border: 2px solid #2196f3;
}

.calendar-day.has-events {
  background-color: #fff3cd;
}

.day-number {
  font-weight: 600;
  margin-bottom: 0.2rem;
  font-size: 1.1rem;
}

.day-events {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.event-item {
  padding: 4px 4px;
  border-radius: 4px;
  font-size: 0.9rem;
  color: white;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.2s ease;
  min-height: 110px;
  display: flex;
  align-items: flex-start;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  position: relative;
}

.event-item:hover {
  opacity: 0.8;
  transform: scale(1.02);
}

.event-content {
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.event-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-weight: bold;
  font-size: 13px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin-bottom: 3px;
}

.event-numero {
  font-weight: bold;
  color: #ffffff;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 1;
  font-size: 13px;
  line-height: 1.2;
}

.event-duplicado-row {
  width: 100%;
  margin-bottom: 3px;
  display: flex;
  justify-content: flex-start;
}

.event-duplicado-badge {
  margin-left: 0;
  padding: 1px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 800;
  line-height: 1.2;
  white-space: nowrap;
  flex-shrink: 0;
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.6);
  color: #ffffff;
  display: inline-block;
}

.event-estado-wrapper {
  width: 100%;
  margin-bottom: 3px;
  display: flex;
  justify-content: flex-start;
}

.event-estado {
  padding: 4px 8px;
  border-radius: 3px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
  overflow: visible;
  text-overflow: ellipsis;
  line-height: 1.3;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  display: inline-block;
  border: 1px solid rgba(255, 255, 255, 0.5);
  /* El color de fondo se aplica dinámicamente desde getEventEstadoBadgeColor */
  /* El color del texto siempre será blanco para contraste */
  color: #ffffff !important;
}

.event-titulo {
  font-size: 12px;
  font-weight: 500;
  color: #ffffff;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.3;
  max-height: 2.6em;
  margin-top: 2px;
}

.event-responsable {
  font-size: 11px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.95);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 2px;
}

.event-tarea-parte {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.85);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
  margin-top: 2px;
  line-height: 1.3;
}

.event-tarea-parte .sin-tarea-keikaku {
  color: #f44336 !important;
  font-weight: 600;
}

.event-material {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.8);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 2px;
  font-weight: 500;
}

.event-facturable-icon {
  position: absolute;
  bottom: 6px;
  right: 8px;
  background-color: rgba(30, 58, 95, 0.9);
  color: white;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.more-events {
  font-size: 0.7rem;
  color: #6c757d;
  font-style: italic;
  text-align: center;
  margin-top: 2px;
}

/* Responsive */
@media (max-width: 768px) {
  .calendar-day {
    min-height: 60px;
    padding: 0.25rem;
  }
  
  .event-item {
    font-size: 0.65rem;
    padding: 1px 2px;
  }
  
  .calendar-weekday {
    padding: 0.5rem 0.25rem;
    font-size: 0.875rem;
  }
}

/* Estilos para filas de albaranes según su estado - SIN EFECTOS HOVER */
.el-table .albaran-necesita-atencion,
.el-table tbody tr.albaran-necesita-atencion {
  background-color: #F1C40F !important; /* Amarillo - Solo estados que requieren acción: PREPARACIÓN, REVISAR DEVOLUCIÓN, INCIDENCIA */
  cursor: pointer !important; /* Cursor de mano para indicar que es clickeable */
}

.el-table .albaran-necesita-atencion td,
.el-table tbody tr.albaran-necesita-atencion td {
  color: #000000 !important;
  font-weight: 500;
  background-color: #F1C40F !important;
  cursor: pointer !important; /* Cursor de mano para indicar que es clickeable */
}

.el-table .albaran-entregado,
.el-table tbody tr.albaran-entregado {
  background-color: #ffc107 !important; /* Amarillo - ENTREGADO */
  cursor: pointer !important; /* Cursor de mano para indicar que es clickeable */
}

.el-table .albaran-devuelto,
.el-table tbody tr.albaran-devuelto {
  background-color: #28a745 !important; /* Verde - DEVUELTO */
  cursor: pointer !important; /* Cursor de mano para indicar que es clickeable */
}

.el-table .albaran-ok td,
.el-table tbody tr.albaran-ok td {
  color: #ffffff !important;
  background-color: #2ECC71 !important;
  cursor: pointer !important; /* Cursor de mano para indicar que es clickeable */
}

.el-table .albaran-cerrado,
.el-table tbody tr.albaran-cerrado {
  background-color: #3498DB !important; /* Azul - Cerrado */
  cursor: pointer !important; /* Cursor de mano para indicar que es clickeable */
}

.el-table .albaran-cerrado td,
.el-table tbody tr.albaran-cerrado td {
  color: #ffffff !important;
  background-color: #3498DB !important;
  cursor: pointer !important; /* Cursor de mano para indicar que es clickeable */
}

.el-table .albaran-cerrado-no-facturable,
.el-table tbody tr.albaran-cerrado-no-facturable {
  background-color: #2ECC71 !important; /* Verde - Cerrado no facturable */
  cursor: pointer !important; /* Cursor de mano para indicar que es clickeable */
}

.el-table .albaran-cerrado-no-facturable td,
.el-table tbody tr.albaran-cerrado-no-facturable td {
  color: #ffffff !important;
  background-color: #2ECC71 !important;
  cursor: pointer !important;
}

.el-table .albaran-incidencia,
.el-table tbody tr.albaran-incidencia {
  background-color: #dc3545 !important; /* Rojo - Incidencia */
  cursor: pointer !important; /* Cursor de mano para indicar que es clickeable */
}

.el-table .albaran-incidencia td,
.el-table tbody tr.albaran-incidencia td {
  color: #ffffff !important;
  background-color: #dc3545 !important;
  cursor: pointer !important;
}

/* DESACTIVAR COMPLETAMENTE TODOS LOS EFECTOS HOVER - Selectores muy específicos */
.el-table tbody tr.albaran-necesita-atencion:hover,
.el-table tbody tr.albaran-necesita-atencion:hover > td,
.el-table tbody tr.albaran-necesita-atencion:hover > td > div,
.el-table tbody tr.albaran-necesita-atencion:hover > td > span,
.el-table__body-wrapper .el-table__body tbody tr.albaran-necesita-atencion:hover,
.el-table__body-wrapper .el-table__body tbody tr.albaran-necesita-atencion:hover > td,
.el-table__body-wrapper .el-table__body tbody tr.albaran-necesita-atencion:hover > td > div,
.el-table__body-wrapper .el-table__body tbody tr.albaran-necesita-atencion:hover > td > span {
  background-color: #F1C40F !important;
  color: #000000 !important;
}

.el-table tbody tr.albaran-ok:hover,
.el-table tbody tr.albaran-ok:hover > td,
.el-table tbody tr.albaran-ok:hover > td > div,
.el-table tbody tr.albaran-ok:hover > td > span,
.el-table__body-wrapper .el-table__body tbody tr.albaran-ok:hover,
.el-table__body-wrapper .el-table__body tbody tr.albaran-ok:hover > td,
.el-table__body-wrapper .el-table__body tbody tr.albaran-ok:hover > td > div,
.el-table__body-wrapper .el-table__body tbody tr.albaran-ok:hover > td > span {
  background-color: #2ECC71 !important;
  color: #ffffff !important;
}

.el-table tbody tr.albaran-cerrado:hover,
.el-table tbody tr.albaran-cerrado:hover > td,
.el-table tbody tr.albaran-cerrado:hover > td > div,
.el-table tbody tr.albaran-cerrado:hover > td > span,
.el-table__body-wrapper .el-table__body tbody tr.albaran-cerrado:hover,
.el-table__body-wrapper .el-table__body tbody tr.albaran-cerrado:hover > td,
.el-table__body-wrapper .el-table__body tbody tr.albaran-cerrado:hover > td > div,
.el-table__body-wrapper .el-table__body tbody tr.albaran-cerrado:hover > td > span {
  background-color: #3498DB !important;
  color: #ffffff !important;
}

.el-table tbody tr.albaran-cerrado-no-facturable:hover,
.el-table tbody tr.albaran-cerrado-no-facturable:hover > td,
.el-table tbody tr.albaran-cerrado-no-facturable:hover > td > div,
.el-table tbody tr.albaran-cerrado-no-facturable:hover > td > span,
.el-table__body-wrapper .el-table__body tbody tr.albaran-cerrado-no-facturable:hover,
.el-table__body-wrapper .el-table__body tbody tr.albaran-cerrado-no-facturable:hover > td,
.el-table__body-wrapper .el-table__body tbody tr.albaran-cerrado-no-facturable:hover > td > div,
.el-table__body-wrapper .el-table__body tbody tr.albaran-cerrado-no-facturable:hover > td > span {
  background-color: #2ECC71 !important;
  color: #ffffff !important;
}

.el-table tbody tr.albaran-incidencia:hover,
.el-table tbody tr.albaran-incidencia:hover > td,
.el-table tbody tr.albaran-incidencia:hover > td > div,
.el-table tbody tr.albaran-incidencia:hover > td > span,
.el-table__body-wrapper .el-table__body tbody tr.albaran-incidencia:hover,
.el-table__body-wrapper .el-table__body tbody tr.albaran-incidencia:hover > td,
.el-table__body-wrapper .el-table__body tbody tr.albaran-incidencia:hover > td > div,
.el-table__body-wrapper .el-table__body tbody tr.albaran-incidencia:hover > td > span {
  background-color: #dc3545 !important;
  color: #ffffff !important;
}

/* Resaltar filas duplicadas HOY por tarea Keikaku (manteniendo el color de estado) */
.el-table__row.albaran-duplicado-keikaku-hoy > td,
.el-table__body-wrapper .el-table__body tbody tr.albaran-duplicado-keikaku-hoy > td {
  box-shadow: inset 4px 0 0 #f0ad4e;
}

/* Desactivar el hover por defecto de Element UI completamente */
.el-table__row.albaran-necesita-atencion:hover,
.el-table__row.albaran-ok:hover,
.el-table__row.albaran-cerrado:hover,
.el-table__row.albaran-cerrado-no-facturable:hover,
.el-table__row.albaran-incidencia:hover {
  background-color: inherit !important;
}

.el-table__row.albaran-necesita-atencion:hover .el-table__cell,
.el-table__row.albaran-ok:hover .el-table__cell,
.el-table__row.albaran-cerrado:hover .el-table__cell,
.el-table__row.albaran-cerrado-no-facturable:hover .el-table__cell,
.el-table__row.albaran-incidencia:hover .el-table__cell {
  background-color: inherit !important;
}

/* Estilo para badge de estado en el listado */
.estado-badge-listado {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
  border: 1px solid rgba(255, 255, 255, 0.5);
  /* El color de fondo se aplica dinámicamente desde getEstadoColor() */
  /* El color del texto siempre será blanco para contraste */
  color: #ffffff !important;
}

/* Estilo para badge de clon - colores que contrastan bien sobre amarillo */
.badge-clon {
  background-color: #6f42c1 !important; /* Púrpura */
  color: #ffffff !important;
  border: 1px solid #5a32a3 !important;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.65rem;
  font-weight: 600;
  display: inline-block;
  width: fit-content;
}

.badge-clon i {
  margin-right: 2px;
  font-size: 0.6rem;
}
</style> 